// src/data/quizzes.js
import images from "../assets/images/images";



const quizzes = {
  1 : [
    {
      
      question: "Nas vias públicas, os peões devem transitar...",
      options: ["Pelos passeios, pistas ou passagens a eles destinados ou, se não existirem pelas bermas", "Pela faixa de rodagem, mesmo que existam bermas.", "Sempre pelas bermas, mesmo que existem pistas especiais destinadas a eles", "Pelos passeios, se empurram um veículo de tracção manual." ],
      correctAnswer: "Pelos passeios, pistas ou passagens a eles destinados ou, se não existirem pelas bermas",
      image: images.image1, // Substitua por URLs reais
    },
    {
      question: "São evitáveis os acidentes de viação?",
      options: ["Não, porque os acidentes ocorrem por acaso.", "Sim, podemos aprender a evitá-los e a reduzir as suas consequências.", "Sim, mas só se o estado das estradas melhorar.", "Sim, excepto os causados pelo mau estado dos pneus."],
      correctAnswer: "Sim, podemos aprender a evitá-los e a reduzir as suas consequências.",
      image: images.image6, // Substitua por URLs reais
    },
    {
      question: "Ao travar, o que é que pode acontecer se os travões actuarem de forma desigual sobre as rodas do mesmo eixo?",
      options: ["Melhora a estabilidade do veículo.", "As rodas bloqueiam.", "O veículo altera a sua trajectória.", "A distância de paregem diminui."],
      correctAnswer: "O veículo altera a sua trajectória.",
      image: images.image7, // Substitua por URLs reais
    },
    {
      question: "O que indica o sinal?",
      options: ["Trânsito proibido a tractores agrícolas.", "Fim da proibição de circulação de tractores agrícolas.", "Trânsito proibido a veículos de construção."],
      correctAnswer: "Trânsito proibido a tractores agrícolas.",
      image: images.image8, // Substitua por URLs reais
    },
    {
      question: "A condução defensiva deve ser mais 'pro-activa', isso significa que:?",
      options: ["Devem prever as situações antes de acontecerem e mesmo que não aconteçam prever a probabilidade de que aconteçam.", "Devem advinhar as situações de perigo e concentrar-se em aproximar-se o mais possível da berma para se proteger.", "Deve estar atento aos ruídos estranhos dos veículos no trânsito e sinalizar.", "Deve ser mais rápido e activa para sair rapidamente das zonas de perigo."],
      correctAnswer: "Devem prever as situações antes de acontecerem e mesmo que não aconteçam prever a probabilidade de que aconteçam.",
      image: images.image12, // Substitua por URLs reais
    },
    {
      question: "Pode transportar bebidas alcoólicas na parte do veículo reservada aos passageiros?",
      options: ["Sim.", "Sim, se o condutor não estiver sob influência de álcool.", "Não, já que é proibido o porte e transporte de bebidas alcoólicas nesta parte do veículo.", "Sim, sempre que o condutor não tome nada de álcool."],
      correctAnswer: "Não, já que é proibido o porte e transporte de bebidas alcoólicas nesta parte do veículo.",
      image: images.image13, // Substitua por URLs reais
    },
    {
      question: "Se um indivíduo atingir uma TAS de 1.2 g/l às 0 horas, só por volta das:?",
      options: [
        "4 horas do dia seguinte é que terá eliminado completamente o álcool no seu sangue, se dormir bem.", 
        "22 horas do dia seguinte é que terá eliminado completamente o álcool no seu sangue.", 
        "8 horas do dia seguinte é que terá eliminado completamente o álcool no seu sangue.",
        "12 horas do dia seguinte é que terá eliminado completamente o álcool no seu sangue."],
      correctAnswer: "12 horas do dia seguinte é que terá eliminado completamente o álcool no seu sangue.",
      image: images.image14, // Substitua por URLs reais
    },

    {
      question: "Os sistemas de segurança passiva dos veículos, têm a função de:",
  options: ["Transmitir uma sensação de segurança quando se circula a velocidades elevadas.","Evitar os acidentes.", "Evitar ou reduzir as lesões que podem ocorrer no caso de sofrer um acidente."],
      correctAnswer: "Evitar ou reduzir as lesões que podem ocorrer no caso de sofrer um acidente.",
      image: images.image11 // Substitua por URLs reais
    },

    {
      question: "O que indica o sinal?",
  options: ["Trânsito proibido a senhoras.","Paragem proibida.","Paragem obrigatória.", "Fim da proibição de estacionamento."],
      correctAnswer: "Paragem proibida.",
      image: images.image5 // Substitua por URLs reais
    },

    {
      question: "Num veículo equipado com motor Diesel em aceleração, a libertação de muito fumo negro pelo tubo de escape, significa:",
  options: ["Óptima qualidade do combustível.","Que o veículo está a queimar muito óleo.", "Necessidade de regulação da bomba injectora.", "Que o veículo acelera bem."],
      correctAnswer: "Necessidade de regulação da bomba injectora.",
      image: images.image12 // Substitua por URLs reais
    },

    

    {
      question: "Para combater o sono, o melhor remédio é:",
  options: ["Parar de conduzir, descansar e, se necessário, dormir um pouco.","Fechar todas as janelas.", "Conduzir com o banco inclinado para trás.", "Tomar uma bebida com álcool."],
      correctAnswer: "Parar de conduzir, descansar e, se necessário, dormir um pouco.",
      image: images.image21 // Substitua por URLs reais
    },

    {
      question: "A sonolência provocada pela fadiga provoca o aumento:",
  options: ["Do tempo de reacção e não da distância de paragem.", "Do tempo de reacção e da distância de paragem.", "Da distancia de travagem."],
      correctAnswer: "Do tempo de reacção e da distância de paragem.",
      image: images.image17 // Substitua por URLs reais
    },

    {
      question: "O que indica este sinal?",
  options: ["A presença de entrocamento obliquo à esquerda.", "A presença de cancela motorizada ao centro.", "A presensa de ponte móvel."],
      correctAnswer: "A presensa de ponte móvel.",
      image: images.image16 // Substitua por URLs reais
    },

    {
      question: "Os sistemas de segurança passiva dos veiculos...",
  options: ["não são eficazes para reduzir as consequências dos acidentes.", "evitam os acidentes.","devem ser utilizados correctamente, porque o seu mau uso pode ser perigoso.", "têm uma manutenção muito cara e complexa."],
      correctAnswer: "devem ser utilizados correctamente, porque o seu mau uso pode ser perigoso.",
      image: images.image22 // Substitua por URLs reais
    },


    {
      question: "A recolha de informação é efectuada pela condução nocturna. Assim, de noite devo:",
  options: ["Moderar a velocidade.", "Manter a mesma velocidade.", "Aumentar um pouco a velocidade.", "Circular muito devagar."],
      correctAnswer: "Moderar a velocidade.",
      image: images.image23 // Substitua por URLs reais
    },


    {
      question: "O trânsito de veículos ou de animais é feito...",
  options: ["do lado direito das faixas de rodagem e o mais próximo possível das bermas ou passeios.","pela esquerda das faixas de rodagem e o mais próximo possível das bermas ou passeios, mas a uma distância que permite evitar qualquer acidente.", "próximo do eixo da via."],
      correctAnswer: "pela esquerda das faixas de rodagem e o mais próximo possível das bermas ou passeios, mas a uma distância que permite evitar qualquer acidente.",
      image: images.image26 // Substitua por URLs reais
    },


    {
      question: "Factores de risco são:",
  options: ["Todos os factores externos ao condutor", "Todos os factores que aumentem o risco de acidente.", "Todas as marcas rodoviárias que contenham riscos", "Todos os elementos externos que possam provocar na pintura."],
      correctAnswer: "Todos os factores que aumentem o risco de acidente.",
      image: images.image25 // Substitua por URLs reais
    },


    {
      question: "O que devem fazer os condutores se o sinal luminoso desta intersecção está avariado?",
  options: ["Ceder a passagem aos condutores que se apresentem pela esquerda.", "Ceder a passagem a todos os condutores que se apresentem pela via transversal.", "Continuar a marcha, já que tenho prioridade de passagem.", "Ceder a passagem aos condutores que se apresentem pela direita."],
      correctAnswer: "Ceder a passagem aos condutores que se apresentem pela direita.",
      image: images.image24 // Substitua por URLs reais
    },


    {
      question: "O significado deste sinal é:",
  options: ["Fim de duas vias.", "Fim de via à esquerda", "Entroncamento agudo da direita.", "Fim de via à direita."],
      correctAnswer: "Entroncamento agudo da direita.",
      image: images.image27 // Substitua por URLs reais
    },


    {
      question: "Os automóveis classificam-se em:",
  options: ["Motociclos, Ciclomotores, Triciclos, ligeiros e Pesados.", "Ligeiros, Pesados e Mistos.", "Ligeiros e Pesado.", "Ligeiros, Pesados e Motociclos."],
      correctAnswer: "Ligeiros e Pesado.",
      image: images.image28 // Substitua por URLs reais
    },


    {
      question: "É aconselhável viajar à noite para evitar a fadiga?",
  options: ["Sim, se a viagem é longa.", "Não, porque o sono aparece mais facilmente.", "Sim, viajar durante a noite é sempre mais seguro.", "Sim, porque há menos tráfego."],
      correctAnswer: "Não, porque o sono aparece mais facilmente.",
      image: images.image29 // Substitua por URLs reais
    },


    {
      question: "Deve utilizar-se as luzes de perigo...",
  options: ["apenas quando o veículo esteja a ser rebocado.", "para avisar os outros utentes que o veículo vai fazer marcha atrás.", "ao estacionar em segunda fila.","em caso de imobilização por acidente ou avaria, se origina perigo para os demias utentes da via."],
      correctAnswer: "em caso de imobilização por acidente ou avaria, se origina perigo para os demias utentes da via.",
      image: images.image30 // Substitua por URLs reais
    },


    {
      question: "Atirar do veículo ou abandonar na via objectos ou substâncias, constitui contravenção:",
  options: ["Leve.", "Média.","Grave.", "Muito grave."],
      correctAnswer: "Média.",
      image: images.image31 // Substitua por URLs reais
    },

    {
      question: "O que indica a marca rodoviária branca?",
  options: ["Indica a existência de lomba.", "Indica a existência de bandas sonoras.", "Indica a redunção de filas de trânsito."],
      correctAnswer: "Indica a existência de lomba.",
      image: images.image32 // Substitua por URLs reais
    },


    {
      question: "O que indica o sinal?",
  options: ["Sentido proibido", "Trânsito proibido.","Trânsito proibido a automóveis ligeiros de passageiros."],
      correctAnswer: "Trânsito proibido.",
      image: images.image33 // Substitua por URLs reais
    },
   


    // Adicione até 25 perguntas
  ],

  
  2: [
    {
      question: "Quando é permitido ultrapassar pelo lado direito?",
      options: [
        "Quando há faixa de trânsito livre",
        "Quando o veículo da frente está sinalizando para a esquerda",
        "Nunca é permitido"
      ],
      correctAnswer: "Quando o veículo da frente está sinalizando para a esquerda",
      image: images.image6
    },
    {
      question: "O que indica este sinal?",
      options: ["Desvio da fila de trânsito para a direita", "Desvio da fila de trânsito para esquerda", "Desvio e aumento de filas de trânsito para a esquerda"],
      correctAnswer: "Desvio da fila de trânsito para esquerda",
      image: images.image34
    },

    
    
    {
      question: "É necessário verificar com frequência o sistema de iluminação?",
      options: ["Não, porque se deve fazer uicamete uma oficia.", "Sim, mudando todos os fusíveis.", "Sim, para se assegurar que todas as luzes funcionam e que os faróis estão bem regulados.", "Não, é suficiete a revisão na inspecção periódica obrigatória."],
      correctAnswer: "Sim, para se assegurar que todas as luzes funcionam e que os faróis estão bem regulados.",
      image: images.image35
    },

    {
      question: "Que veículos devem ter seguro de responsabilidade civil para transitar na via pública?",
      options: ["Apenas os veículos automóveis.", "Só os ciclomotores.", "Os veículos a motor.", "Todos os veículos."],
      correctAnswer: "Os veículos a motor.",
      image: images.image36
    },

    {
      question: "O que indica o sinal?",
      options: ["A existência de uma berma baixa à direita.","A existência de uma berma baixa à esquerda.", "A existência de um terreno falso à direita."],
      correctAnswer:"A existência de uma berma baixa à direita.",
      image: images.image37
    },


    {
      question: "Pode transportar uma criança neste motociclo?",
      options: ["Não, nunca.", "Sim, se tem menos 7 anos e leva o capacete devidamente ajustado e apertado.", "Sim, num assento adicional.", "Sim, se tem pelo menos 3 anos e leva o capacete devidamente ajustado e apertado."],
      correctAnswer: "Sim, se tem menos 7 anos e leva o capacete devidamente ajustado e apertado.",
      image: images.image38
    },


    {
      question: "O significado deste sinal é:",
      options: ["Zona de máquinas de agricultura.", "Pista obrigatória para máquinas.", "Máquinas.", "Zona de máquinas de escavação."],
      correctAnswer: "Máquinas.",
      image: images.image39
    },


    {
      question: "Dentro das localidades, durante a noite:",
      options: ["É obrigatória a substituição dos sinais sonoros pelos sinais luminosos.", "Não é obrigatória a substituição dos sinais sonoros pelos sinais luminosos.", "É obrigatória a substituição dos sinais sonoros pelos sinais gestuais.", "É escolha do condutor a substituição dos sinais sonoros pelos sinais gestuias."],
      correctAnswer: "É obrigatória a substituição dos sinais sonoros pelos sinais luminosos.", 
      image: images.image40
    },


    {
      question: "A capacidade de o condutor prever e antecipar aumenta:",
      options: ["Com a idade do condutor.", "Com a categoria do veículo", "Com a experiência.", "Com a velocidade do veículo."],
      correctAnswer: "Com a experiência.",
      image: images.image41
    },


    {
      question: "O controlo dinâmico do veículo é uma das tarefas de condução e é...",
      options: ["Efectuado através do sistema de direcção.", "Efectuado através da definição da sua velocidade e da sua trajectória.", "Efectuado através da aceleração e travagem do veículo."],
      correctAnswer: "Efectuado através da definição da sua velocidade e da sua trajectória.",
      image: images.image42
    },


    {
      question: "Fumar enquanto conduz...",
      options: ["é proibido.", "é aconselhavel, pois ajuda a manter a atenção.", "reduz a agressividade do condutor", "pode afectar a atenção na condução."],
      correctAnswer: "pode afectar a atenção na condução.",
      image: images.image43
    },

    {
      question: "Na via pública, a carga e descarga de um veículo deve ser feita:",
      options: ["Sempre pela esquerda", "Pela retaguarda ou pelo lado permitido para a paragem do veículo.", "Sempre pela retaguarda", "Sempre pela direita."],
      correctAnswer: "Pela retaguarda ou pelo lado permitido para a paragem do veículo.",
      image: images.image44
    },

    {
      question: "O significado deste sinal é:",
      options: ["Subida de inclinação acentuada.", "Descida de inclinação.", "Subida de inclinação acentuada para camiões.", "Descida de inclinação acentuada para camiões."],
      correctAnswer: "Subida de inclinação acentuada.",
      image: images.image45
    },

    {
      question: "O que indica este sinal?",
      options: ["Pavimento escorregadio.", "Visibilidade reduzida.", "Inicio de estrada alcatroada."],
      correctAnswer: "Visibilidade reduzida.",
      image: images.image46
    },

    {
      question: "As pessoas que são encontradas a conduzir sem possuír carta de condução:",
      options: ["Não podem ser punidas.", "São punidas apenas com uma multa de 500 Mt", "São punidas com pena de prisão de um a três dias e multa de 5000 Mt.", "São punidas com pena de prisão de três dias a seis meses e multa de 5000 Mt."],
      correctAnswer: "São punidas com pena de prisão de três dias a seis meses e multa de 5000 Mt.",
      image: images.image47
    },

    {
      question: "Um dos elementos de segurança é a almofada de ar (AirBag)?",
      options: ["Sim, de segurança passiva.", "Não.", "Sim, de segurança activa."],
      correctAnswer: "Sim, de segurança passiva.",
      image: images.image50
    },

    {
      question: "Os condutores de motociclos simples, fora das localidades, não devem exceder a velocidade instantânea de:",
      options: ["60 km/h", "70 km/h", "80 km/h", "90 km/h"],
      correctAnswer: "90 km/h",
      image: images.image48
    },

    {
      question: "As luzes de máximos, com nevoeiro (cacimba):",
      options: ["Só devem ser usados à noite.", "Devem ser evitadas, em especial à noite.", "Devem obrigatoriamente ser usadas.", "Só devem ser usados de dia."],
      correctAnswer: "Devem ser evitadas, em especial à noite.",
      image: images.image49
    },

    {
      question: "O significado deste sinal é:",
      options: ["Zona de paragem em fila.", "Zona onde só podem passar três carros de cada vez.", "Congestionamento de tráfego.", "Zona de estacionamento em fila"],
      correctAnswer: "Congestionamento de tráfego.",
      image: images.image51
    },

    {
      question: "Os jovens, têm mais possibilidades de ter acidentes rodoviários?",
      options: ["Sim, a sua visão é mais reduzida.", "Não.", "Sim, devido à falta de reflexos.", "Sim, normalmente fazem uma avaliação incorrecta dos riscos."],
      correctAnswer: "Sim, normalmente fazem uma avaliação incorrecta dos riscos.",
      image: images.image52
    },

    {
      question: "Qual é a velocidade instantânea que não devem exceder os automóveis ligeiros de passageiros e mistos dentro das localidades?",
      options: ["40 km/h.", "50 km/h, se tem reboque.", "60 km/h.", "70 km/h."],
      correctAnswer: "60 km/h.",
      image: images.image53
    },

    {
      question: "A definição de estacionamento é:",
      options: ["Imobilização de um veículo que constitua paragem e que seja motivada por circustâncias próprias da circulação.", "Imobilização de um veículo que não constitua paragem e que seja motivada por circustâncias próprias da circulação.", "Imobilização de um veículo que não constitua paragem e que não seja motivada por circustâncias próprias da circulação.", "Imobilização de um veículo que constitua paragem e que seja motivada por circustâncias de excesso de tráfego."],
      correctAnswer: "Imobilização de um veículo que não constitua paragem e que não seja motivada por circustâncias próprias da circulação.",
      image: images.image54
    },

    {
      question: "Como o álcool afecta tarefa de conduzir?",
      options: ["Melhora a apreciação das velocidades.", "Aumenta a atenção do condutor, assim que as distracções são reduzidas.", "Melhora a apreciação das distâncias.", "Reduz o campo de visão do condutor."],
      correctAnswer: "Reduz o campo de visão do condutor.",
      image: images.image55
    },

    {
      question: "O vento afecta a estabilidade do veículo:",
      options: ["Particularmente em veículos de caixa aberta.", "Não.","Particularmente quando é muito forte em túneis.", "Particularmente quando é muito forte e sopra lateralmente."],
      correctAnswer: "Particularmente quando é muito forte e sopra lateralmente.",
      image: images.image56
    },

    {
      question: "O que indica o sinal?",
      options: ["Advertência da direcção de saída.", "Pré-advertêncoa da direcção de saída.", "Direcção de saída."],
      correctAnswer: "Pré-advertêncoa da direcção de saída.",
      image: images.image57
    },

    // Adicione até 25 perguntas
  ],
  // Adicione mais quizzes conforme necessário
  3: [
    {
      question: "Se pretender inverter o sentido de marcha numa via cuja largura não permite fazê-lo sem prejudicar o trânsito, deve:",
      options: [
        "Fazer a manobra, mesmo que prejudique o trânsito.",
        "Continuar até encontrar um local adequado onde não prejudique o trânsito.",
        "Inverter o sentido de marcha com o menor número de manobras possíveis.",
        "Parar o veículo perto do eixo da via e esperar até que não haja tráfego."
      ],
      correctAnswer: "Continuar até encontrar um local adequado onde não prejudique o trânsito.",
      image: images.image58
    },
    {
      question: "O condutor, quando muda de direcção, tem que ceder passagem aos peões que estejam a atravessar a faixa de rodagem?",
      options: [
        "Sim.",
        "Não.",
        "Sim, mas só aos que façam pela passagem para peões."
      ],
      correctAnswer: "Sim.",
      image: images.image59
    },
    {
      question: "De que modo, o consumo de álcool altera o comportamento do condutor?",
      options: [
        "Aumenta a autoconfiança, e por isso aumentam os riscos.",
        "Reduz a sua agressividade na condução.",
        "Diminui o seu tempo de reacção.",
        "Diminui os seus erros na condução."
      ],
      correctAnswer: "Aumenta a autoconfiança, e por isso aumentam os riscos.",
      image: images.image60
    },
    {
      question: "O que indica o sinal?",
      options: [
        "Pista obrigatória para peões.",
        "Passagem de peões.",
        "Passagem desnivelada para peões."
      ],
      correctAnswer: "Passagem de peões.",
      image: images.image10
    },
    {
      question: "Pode uma criança com idade inferior a 3 anos viajar no banco de frente do automovél?",
      options: [
        "Não, em nenhum caso.",
        "Sim, sempre que utilize o cinto de segurança.",
        "Sim, quando o automovél não tenha nenhum cinto de segurança.",
        "Sim, utilizando um sistema de retenção virado para retaguarda e com a almofada de ar frontal (airbag) do lado do passageiro desactivado."
      ],
      correctAnswer: "Sim, utilizando um sistema de retenção virado para retaguarda e com a almofada de ar frontal (airbag) do lado do passageiro desactivado.",
      image: images.image61
    },

    {
      question: "Considera-se sob influência de álcool, o condutor que apresente uma taxa de álcool igual ou superior a:",
      options: [
        "0.3 mg/l no teste de ar expirado, ou de 0.6 mg/l, em teste sanguíneo.",
        "0.6 mg/l no teste de ar expirado, ou de 0.9 mg/l em teste sanguíneo.",
        "0.1 mg/l no teste de ar expirado, ou de 0.3 mg/l em teste sanguíneo."
      ],
      correctAnswer: "0.3 mg/l no teste de ar expirado, ou de 0.6 mg/l, em teste sanguíneo.",
      image: images.image62
    },
    {
      question: "O que se entende por inconsciência?",
      options: [
        "O aumento da frequência das pulsações por minuto.",
        "O estado em que o peito da vítima de acidente de viação, desce e sobe regularmente.",
        "O estado no qual o cérebro não está a funcionar bem.",
        "A perda de sangue, resultante da abertura dos vasos sanguíneos."
      ],
      correctAnswer: "O estado no qual o cérebro não está a funcionar bem.",
      image: images.image63
    },
    {
      question: "Em caso de avaria, os sinais de pre-sinalização de perigo devem colocar-se por forma a ficar bem vísiveis a uma distância de...",
      options: [
        "10 metros.",
        "pelo menos 100 metros.",
        "pelo menos 50 metros.",
        "pelo menos 25 metros."
      ],
      correctAnswer: "pelo menos 100 metros.",
      image: images.image64
    },
    {
      question: "Deve ter alguma precaução especial quando circula dentro das localidades?",
      options: [
        "Sim, utilizar os sinais sonoros quando se aproxima de peões.",
        "Sim, moderar a velocidade, especilmente nas vias marginadas por edificações.",
        "Não.",
        "Sim, apenas não ficar imobilizado nos cruzamentos ou entrocamentos."
      ],
      correctAnswer: "Sim, moderar a velocidade, especilmente nas vias marginadas por edificações.",
      image: images.image65
    },
    {
      question: "O que indica a marca rodoviária amarela?",
      options: [
        "Proibição de estacionamento.",
        "Proibição de paragem.",
        "Estacionamento condicionado."
      ],
      correctAnswer: "Proibição de estacionamento.",
      image: images.image66
    },
    {
      question: "O que indica o sinal de perigo?",
      options: [
        "Controlo policial por pirilampos.",
        "Aproximação de uma estrada com prioridade.",
        "Sinalização luminosa."
      ],
      correctAnswer: "Sinalização luminosa.",
      image: images.image67
    },
    {
      question: "Nesta via de dois sentidos, posso ultrapassar o veículo azul que assinala a sua intenção de ultrapassar o veículo que o procede?",
      options: [
        "Sim, pela direita.",
        "Sim, se existir espaço suficiente para os três na faixa de rodagem.",
        "Não.",
        "Sim, pela esquerda."
      ],
      correctAnswer: "Não.",
      image: images.image68
    },
    {
      question: "Das seguintes, qual ou quais não fazem parte das virtudes profissionais, necessárias para a boa condução de veículos automóveis:",
      options: [
        "Egoísmo.",
        "Honestidade.",
        "Responsabilidade.",
        "Cortesia e boas maneiras."
      ],
      correctAnswer: "Egoísmo.",
      image: images.image69
    },
    {
      question: "O que indica o sinal?",
      options: [
        "Proibição de circular à velocidade máxima de 60 km/h na fila a direita.",
        "Obrigação de circular à velocidade mínima de 60 km/h na fila à direita.",
        "Obrigação de circular à velocidade mínima de 60 km/h na fila à esquerda."
      ],
      correctAnswer: "Obrigação de circular à velocidade mínima de 60 km/h na fila à direita.",
      image: images.image70
    },
    {
      question: "O sono pode provocar um acidente durante o dia?",
      options: [
        "Não, esse tipo de acidente só acontecem à noite.",
        "Sim, mas apenas durante as primeiras horas da manhâ.",
        "Sim, os acidentes motivados pelo sono também acontecem durante o dia.",
        "Sim, mas só se conduz sob a influência de álcool."
      ],
      correctAnswer: "Sim, os acidentes motivados pelo sono também acontecem durante o dia.",
      image: images.image71
    },

    {
      question: "O condutor, pode fazer a verificação do nível do óleo no motor do veículo?",
      options: [
        "Sim, desde que mantenha o motor do veículo a trabalhar.",
        "Sim, desde que saiba a forma correcta de verificação.",
        "Não, apenas técnicos especializados o podem fazer."
      ],
      correctAnswer: "Sim, desde que saiba a forma correcta de verificação.",
      image: images.image72
    },

    {
      question: "O que indica o sinal?",
      options: [
        "Pista obrigatória para veículos de tracção animal.",
        "Pista obrigatória para cavaleiros.",
        "Pista obrigatória para veículos de tracção manual."
      ],
      correctAnswer: "Pista obrigatória para veículos de tracção manual.",
      image: images.image73
    },
    {
      question: "Para a iluminação da via, os condutores devem ligar as luzes de:",
      options: [
        "Médios ou máximos.",
        "Mínimos ou máximos.",
        "Mínimos ou médios."
      ],
      correctAnswer: "Médios ou máximos.",
      image: images.image74
    },
    {
      question: "Uma mulher grávida, é obrigada a usar o cinto de segurança?",
      options: [
        "Sim, mas apenas fora das localidades.",
        "Não, porque é prejudicial para a criança.",
        "Sim e é muito importante que esteja bem colocado porque senão, tanto ela como a criança, podem sofrer lesões em caso de acidente.",
        "Não é obrigatório, mas é aconselhavel."
      ],
      correctAnswer: "Sim e é muito importante que esteja bem colocado porque senão, tanto ela como a criança, podem sofrer lesões em caso de acidente.",
      image: images.image75
    },
    {
      question: "A condução nocturna deve influnciar a velocidade a que circulo?",
      options: [
        "Sim, porque de noite pode-se circular um pouco mais rápido, dentro dos limites, porque existe menos trânsito.",
        "Não, porque quando a visibilidade é menor devo ligar as luzes de estrada.",
        "Não, porque se ligar as luzes de estrada vejo melhor a via do que durante o dia.",
        "Sim, porque influncia a recolha de informação."
      ],
      correctAnswer: "Sim, porque influncia a recolha de informação.",
      image: images.image77
    },
    {
      question: "O significado deste sinal é:",
      options: [
        "Parque de estacionamento para automóveis pesados de mercadorias de peso total superior a 10 Toneladas.",
        "Parque de estacionamento para automóveis pesados de passageiros de peso total superior a 10 Toneladas.",
        "Parque de estacionamento para automóveis pesados de passageiros de peso total superior a 10 Kilos.",
        "Parque de estacionamento para todos os automóveis de peso total superior a 10 Toneladas."
      ],
      correctAnswer: "Parque de estacionamento para automóveis pesados de mercadorias de peso total superior a 10 Toneladas.",
      image: images.image78
    },
    {
      question: "Considera-se morte por acidente de viação:",
      options: [
        "Só aquela que ocorre no local do sinistro.",
        "Aquela que ocorre até 30 dias após o registo do sinistro.",
        "Só aquela que ocorre à caminho da unidade sanitária.",
        "Aquela que ocorre 30 dias depois do registo do sinistro."
      ],
      correctAnswer: "Aquela que ocorre até 30 dias após o registo do sinistro.",
      image: images.image79
    },
    {
      question: "Os sistemas de segurança passiva dos veículos, têm a função de:",
      options: [
        "Evitar ou reduzir as lesões que podem ocorrer no caso de um acidente.",
        "Evitar os acidentes.",
        "Transmitir uma sensação de segurança quando se circula a velocidades elevadas.",
      ],
      correctAnswer: "Evitar ou reduzir as lesões que podem ocorrer no caso de um acidente.",
      image: images.image80
    },
    {
      question: "Assine a afirmação falsa relativa a eventuais efeitos da chuva intensa.",
      options: [
        "O `aquaplanning` pode ser agravado pelo mau estado dos pneumáticos e pela circulação com velocidade excessiva.",
        "A água acumulada no solo pode reduzir a eficácia do funcionamento dos travões.",
        "Quando passar num lençol de água e o veículo deslizar, é aconselhavel pressionar o travão até que a aderência das rodas seja retomada.",
        "O `aquaplanning` pode ser agravado pelo mau estado da suspensão do veículo."
      ],
      correctAnswer: "Quando passar num lençol de água e o veículo deslizar, é aconselhavel pressionar o travão até que a aderência das rodas seja retomada.",
      image: images.image81
    },
    {
      question: "Os condutores devem, para permitir a circulação de um veículo prioritário ou da policia, assinalando devidamente a marcha, que transite numa via congestionada: ",
      options: [
        "Deixar livre uma passagem do lado esquerdo da faixa de rodagem afecta ao seu sentido de circulação, chegando-se o mais possível para a direita e podendo, se necessário, utilizar as bermas, excepto se for numa autoestrada.",
        "Deixar livre uma passagem do lado direito da faixa de rodagem afecta ao seu sentido de circulação, chegando-se o mais possível para a esquerda e podendo, se necessário, utilizar as bermas, excepto se for numa autoestrada.",
        "Deixar livre uma passagem do lado esquerdo da faixa de rodagem afecta ao seu sentido de circulação, chegando-se o mais possível para a direita e podendo, se necessário, utilizar as bermas, sobretudo se for numa autoestrada."
      ],
      correctAnswer: "Deixar livre uma passagem do lado direito da faixa de rodagem afecta ao seu sentido de circulação, chegando-se o mais possível para a esquerda e podendo, se necessário, utilizar as bermas, excepto se for numa autoestrada.",
      image: images.image82
    },
  ]
  ,
  4: [
    {
      question: "Os condutores de veículos prioritários:",
      options: [
        "Podem, se necessário, não observar os sinais dos agentes reguladores de trânsito.",
        "Não podem nunca deixar de observar as regras e os sinais de trânsito.",
        "Podem, se necessário, não observar as regras e os sinais de trânsito, com a excepção dos sinais dos agentes reguladores de trânsito."
      ],
      correctAnswer: "Podem, se necessário, não observar as regras e os sinais de trânsito, com a excepção dos sinais dos agentes reguladores de trânsito.",
      image: images.image83
    },

    {
      question: "Como é feito o processo de eliminação do álcool no organismo",
      options: [
        "Pelo fígado, pelo ar expirado, pela urina e pela transpiração.",
        "Pela urina e pela transpiração.",
        "Pelo ar expirado, pela urina e quantidade de água ingerida.",
        "Pela quantidade de café e água que tome depois de beber"
      ],
      correctAnswer: "Pelo fígado, pelo ar expirado, pela urina e pela transpiração.",
      image: images.image84
    },
    {
      question: "Os condutores devem, nos cruzamentos, entrocamentos e rotundas:",
      options: [
        "Ceder passagem a todos velocípedes.",
        "Ceder passagem aos veículos que se desloquem sobre carris.",
        "Ceder passagem a todos veículos.",
        "Ceder passagem a todos os veículos que se apresentem pela esquerda."
      ],
      correctAnswer: "Ceder passagem aos veículos que se desloquem sobre carris.",
      image: images.image85
    },

    {
      question: "Tomar bebeidas alcoólicas:",
      options: [
        "Em pequenas quantidades não afecta o acto da condução.",
        "Reduz a descoordenação motora e a capacidade de avaliação de distâncias.",
        "Aumenta a descoordenação motora e afecta a capacidade de avaliação das distâncias.",
        "Aumenta a descoordenação motora e reduz o risco de acidente."
      ],
      correctAnswer: "Aumenta a descoordenação motora e afecta a capacidade de avaliação das distâncias.",
      image: images.image86
    },
    {
      question: "Se perceber o principio de um incêndio:",
      options: [
        "Actue de imediato, desligando as luzes do veículo e utilizando um extintor.",
        "Actue de imediato, desligando o motor do veículo e utilizando um extintor.",
        "Actue de imediato, desligando o ar condicionado do veículo e utilizando um extintor."
      ],
      correctAnswer: "Actue de imediato, desligando o motor do veículo e utilizando um extintor.",
      image: images.image87
    },
    {
      question: "Qual a frase que melhor define `ver` na afirmação `conduzir implica ver, pensar e agir`?",
      options: [
        "Procurar e selecionar informação significativa.",
        "Estar muito atento ao condutor que vai à sua frente.",
        "Olhar o mais longe possivel."
      ],
      correctAnswer: "Procurar e selecionar informação significativa.",
      image: images.image88
    },
    {
      question: "Como devo actuar perante a diminuição da aderência, que provoca o aumento da distância de travagem?",
      options: [
        "Aumentar a velocidade.",
        "Manter a velocidade.",
        "A diminuição da aderência diminui a distância de travagem.",
        "Diminuir a velocidade."
      ],
      correctAnswer: "Diminuir a velocidade.",
      image: images.image89
    },
    {
      question: "A condução de um veículo implica uma estratégia por parte do seu condutor, que inclui:",
      options: [
        "A definição de vários trajectos e do tempo de viagem.",
        "A definição de uma trajectória e de uma velocidade.",
        "A definição dos tempos de descanso durante o trajecto."
      ],
      correctAnswer: "A definição de uma trajectória e de uma velocidade.",
      image: images.image90
    },
    {
      question: "Com o fim de ter uma boa capacidade de manobra e garantir o bom funcionamento dos sistemas de segurança do veículo, o condutor deve regular o assento...",
      options: [
        "por forma a ficar muito próximo do volante, com as pernas e braços encolhidos.",
        "por forma a ficar longe do volante, com as pernas e braços esticados.",
        "por forma a que as pernas e braços fiquem ligeramente fletidos."
      ],
      correctAnswer: "por forma a que as pernas e braços fiquem ligeramente fletidos.",
      image: images.image91
    },
    {
      question: "Quando se circula numa zona com grande intensidade de vento, além de reduzir a velocidade, qual deve ser o comportamento a adoptar:",
      options: [
        "Acelerar para passar mais rapidamente pela zona onde o vento sopra forte.",
        "Segurar o volante com especial suavidade por forma a não contrariar as oscilações do veículo.",
        "Segurar o volante com maior firmeza.",
        "Rodar ligeiramente o volante para o lado contrário à direcção do vento.",
      ],
      correctAnswer: "Segurar o volante com maior firmeza.",
      image: images.image92
    },
    {
      question: "Os condutores com pouco tempo de condução (inexperientes):",
      options: [
        "Têm capacidade menos eficientes na recolha de informações.",
        "As capacidades na recolha da informação não tem relação com experiência, sim com a visão.",
        "Têm capacidades mais acertadas na recolha de informações.",
        "Têm capacidades mais eficientes na recolha de informações.",
      ],
      correctAnswer: "Têm capacidade menos eficientes na recolha de informações.",
      image: images.image93
    },
    {
      question: "O feixe luminoso emitido oelas luzes de cruzamento (médios), devem projectar-se no solo:",
      options: [
        "E iluminá-lo eficazmente, numa distância não superior a 50 metros.",
        "E no mínimo, iluminá-lo a 100 metros.",
        "E iluminá-lo eficazmente, numa distância não superior a 30 metros."
      ],
      correctAnswer: "E iluminá-lo eficazmente, numa distância não superior a 30 metros.",
      image: images.image94
    },
    {
      question: "O sistema nervoso central é afectado por alguns medicamentos.",
      options: [
        "Depende do sexo e peso.",
        "Certo.",
        "Só se não forem receitados por um médico.",
        "Os medicamentos não afectam o sistema nervoso central.",
      ],
      correctAnswer: "Certo.",
      image: images.image95
    },
    {
      question: "A força centrípeta e centrífuga:",
      options: [
        "São forças que actuam no mesmo sentido e se acumulam uma á outra.",
        "São forças que actuam em sentido contrário uma em relação à outra.",
        "Só depende do raio da trajectória não tendo à velocidade nenhuma inflência.",
        "São forças que só ocorrem quando o veículo vai em linha recta.",
      ],
      correctAnswer: "São forças que actuam em sentido contrário uma em relação à outra.",
      image: images.image96
    },
    {
      question: "Como deve ser feita a entrada e saída de passageiros?",
      options: [
        "Sempre pelo lado direito.",
        "Pelo lado direito, se a paragem do veículo for permitida desse lado.",
        "Sempre pelo lado esquerdo."
      ],
      correctAnswer: "Pelo lado direito, se a paragem do veículo for permitida desse lado.",
      image: images.image97
    },
    {
      question: "Entende-se por tarefa de condução aquela que tem como principal objectivo:",
      options: [
        "O autocontrolo no trânsito.",
        "O controlo do trânsito e dos sinais dos outros condutores.",
        "O controlo de um veículo e do espaço envolvente."
      ],
      correctAnswer: "O controlo de um veículo e do espaço envolvente.",
      image: images.image98
    },
    {
      question: "Pode conduzir um automóvel ligeiro com reboque com a carta de condução da categoria B?",
      options: [
        "Sim, desde que o peso bruto do reboque não exceda 750 kg.",
        "Não, é necessária a da categoria C1E.",
        "Sim, desde que o peso bruto do reboque não exceda 3500 kg.",
        "Não, é necessária a da categoria G.",
      ],
      correctAnswer: "Sim, desde que o peso bruto do reboque não exceda 750 kg.",
      image: images.image99
    },
    {
      question: "O significado desde sinal é:",
      options: [
        "Controlo de tráfego a 100 metros.",
        "Controlo de tráfego a 50 metros.",
        "Controlo de tráfego adiante.",
        "Controlo de tráfego com obrigatoriedade de parar.",
      ],
      correctAnswer: "Controlo de tráfego adiante.",
      image: images.image100
    },
    {
      question: "O significado deste sinal é:",
      options: [
        "Convergência de filas à esquerda.",
        "Fim da fila à esquerda",
        "Fim da fila à direita.",
        "Convergência de filas à direita.",
      ],
      correctAnswer: "Fim da fila à direita.",
      image: images.image102
    },
    {
      question: "A linha transversal descontínua, é uma:",
      options: [
        "Linha de cedência de prioridade.",
        "Linha descontinua de aviso.",
        "Linha de paragem obrigatória."
      ],
      correctAnswer: "Linha de cedência de prioridade.",
      image: images.image103
    },
    {
      question: "Nesta situação, se não for possível efectuar o cruzamento com segurança, como deve proceder o condutor?",
      options: [
        "Nada, porque eu tenho prioridade de passagem.",
        "Acelerar para passar antes do veículo que circula em sentido contrário.",
        "Utilizar os sinais sonoros para que o outro condutor pare.",
        "Reduzir a velocidade ou parar, de modo a dar a passagem ao outro veículo.",
      ],
      correctAnswer: "Reduzir a velocidade ou parar, de modo a dar a passagem ao outro veículo.",
      image: images.image104
    },
    {
      question: "O que deve o condutor fazer perante a marca rodoviária de cor branca?",
      options: [
        "Abrandar a marcha.",
        "Circular à sua esquerda, quando a linha fizer a separação de sentidos de trânsito.",
        "Pisar ou transpor a linha."
      ],
      correctAnswer: "Circular à sua esquerda, quando a linha fizer a separação de sentidos de trânsito.",
      image: images.image105
    },
    {
      question: "As ordens dos agentes reguladores do trânsito, prevalecem sobre os sinais luminosos:",
      options: [
        "Verdes.",
        "De qualquer cor.",
        "Amarelos.",
        "Vermelho.",
      ],
      correctAnswer: "De qualquer cor.",
      image: images.image106
    },
    {
      question: "É necessário regular e ajustar o encosto de cabeça para a altura dos ocupantes?",
      options: [
        "Sim, mas só nos bancos da frente.",
        "Não é necessário, porque é apenas um elemento de conforto.",
        "Não, se o veículo tiver cintos de segurança.",
        "Sim, porque pode evitar lesões na zona do pescoço.",
      ],
      correctAnswer: "Sim, porque pode evitar lesões na zona do pescoço.",
      image: images.image107
    },
    {
      question: "O significado deste sinal é:",
      options: [
        "Parque de estacionamento para veículos do Ministério.",
        "Parque de estacionamento para veículos do Parlamento.",
        "Parque de estacionamento para veículos da Polícia.",
        "Parque de estacionamento para veículos do Governo.",
      ],
      correctAnswer: "Parque de estacionamento para veículos da Polícia.",
      image: images.image108
    },

  ]
,
  5: [

    {
      question: "Os sinais sonoros devem ser:",
      options: [
        "Longos,usados de forma moderada e em caso algum devem servir de meio de protesto contra interrupções do trânsito ou como meios de chamamento.",
        "Breves, usados de forma moderada e podem servir de meio de protesto contra interrupções ou como meios de chamamento.",
        "Breves, usados de forma moderada e em caso de algum devem servir de meio de protesto contra interrupções do trânsito ou como meios de chamamento.",
        "Longos e insistentes, usados como forma de protesto contra interrupções do trânsito ou como meios de chamamento.",
      ],
      correctAnswer: "Breves, usados de forma moderada e em caso de algum devem servir de meio de protesto contra interrupções do trânsito ou como meios de chamamento.",
      image: images.image109
    },

    {
      question: "Para ter mais segurança, os peões devem...",
      options: [
        "Transitar pelo lado direito, em relação ao seu sentido de marcha, a não ser que tal comprometa a sua segurança.",
        "fazer o atravessamento da faixa de rodagem o mais lentamente possível.",
        "transitar sempre do lado esquerdo da faixa de rodagem, em relação ao seu sentido de marcha."
      ],
      correctAnswer: "Transitar pelo lado direito, em relação ao seu sentido de marcha, a não ser que tal comprometa a sua segurança.",
      image: images.image110
    },

    {
      question: "O que indica a marca rodoviária?",
      options: [
        "Passagem para ciclistas.",
        "Passagem para peões.",
        "Linha de cedência de prioridade."
      ],
      correctAnswer: "Passagem para peões.",
      image: images.image111
    },

    {
      question: "Ao ligar as luzes, se no painel aparecer o simbolo do farol de cor verde, significa que estão ligadas:",
      options: [
        "As luzes mínimas.",
        "As luzes de estrada (máximos).",
        "As luzes de cruzamento (médios)."
      ],
      correctAnswer: "As luzes de cruzamento (médios).",
      image: images.image112
    },
    {
      question: "Se os ocupantes do veículos não utilizarem o cinto de segurança, o airbag é eficaz?",
      options: [
        "Sim, sempre que os passageiros estejam sentados correctamente.",
        "Não e pode causar lesões graves.",
        "Sim, o airbag é sempre eficaz.",
        "Sim, mas apenas para o condutor.",
      ],
      correctAnswer: "Não e pode causar lesões graves.",
      image: images.image113
    },
    {
      question: "Só pode ser ordenada a suspensão do trânsito por:",
      options: [
        "Ser feriado e haver festejos.",
        "Motivos de segurança, de emergência grave ou de obras, ou com o fim de promover produtos e marcas de automóveis.",
        "Motivos de segurança, de emergência grave ou de obras, ou com o fim de realizar a conservação dos pavimentos, instações e obras de arte.",
        "Ser fim de semana.",
      ],
      correctAnswer: "Motivos de segurança, de emergência grave ou de obras, ou com o fim de realizar a conservação dos pavimentos, instações e obras de arte.",
      image: images.image114
    },
    {
      question: "Se o condutor sofre de uma doença, o que deve fazer para reduzir o risco de ter um acidente?",
      options: [
        "Conhecer os efeitos secundários dos medicamentos.",
        "Deixar de conduzir em todos os casos.",
        "Interromper a medicação que estiver a tomar,se tem que conduzir.",
        "Ignorar os sintomas para evitar distracções.",
      ],
      correctAnswer: "Conhecer os efeitos secundários dos medicamentos.",
      image: images.image115
    },
    {
      question: "Nos veículos destinados ao transporte de passageiros ou mistos...",
      options: [
        "a carga pode ultrapassar os contornos do veículo.",
        "a carga deve estar arrumada por forma a que seja devidamente assegurado o equilíbrio do veículo.",
        "a carga pode ocultar a matricula e os dispositivos de sinalização e iluminação.",
        "a carga deve colocar-se na parte reservada aos passageiros, mesmo que reduza a visibilidade do condutor.",
      ],
      correctAnswer: "a carga deve estar arrumada por forma a que seja devidamente assegurado o equilíbrio do veículo.",
      image: images.image116
    },
    {
      question: "Os sistemas de segurança passiva de veículos...",
      options: [
        "evitam os acidentes.",
        "não são eficazes para reduzir as consequências dos acidentes.",
        "devem ser utilizados correctamente, porque o seu mau uso pode ser perigoso.",
        "têm uma manutenção cara e complexa.",
      ],
      correctAnswer: "devem ser utilizados correctamente, porque o seu mau uso pode ser perigoso.",
      image: images.image130
    },
    {
      question: "Os peões podem transitar pela faixa de rodagem nesta estrada?",
      options: [
        "Não, nesta estrada podem transitar, já que não tem bermas.",
        "Sim, mais só quando necessitem atravessar.",
        "Sim e devem fazê-lo pela esquerda da faixa de rodagem, em relação ao seu sentido de marcha.",
        "Sim, com prudência e por forma a não prejudicar o trânsito de veículos.",
      ],
      correctAnswer: "Sim, com prudência e por forma a não prejudicar o trânsito de veículos.",
      image: images.image117
    },
    {
      question: "É proibido parar ou estacionar, fora das localidades:",
      options: [
        "A menos de 50 metros do cruzamento, entroncamentos, curvas ou lombas de visibilidade reduzida.",
        "A menos de 30 metros do cruzamento, entroncamentos, curvas ou lombas de visibilidade reduzida.",
        "A menos de 20 metros do cruzamento, entroncamentos, curvas ou lombas de visibilidade reduzida.",
        "A menos de 10 metros do cruzamento, entroncamentos, curvas ou lombas de visibilidade reduzida.",
      ],
      correctAnswer: "A menos de 50 metros do cruzamento, entroncamentos, curvas ou lombas de visibilidade reduzida.",
      image: images.image118
    },
    {
      question: "O uso do cinto de segurança nos assentos traseiros...",
      options: [
        "só são obrigatórios fora das localidades.",
        "podem salvar a vida aos seus ocupantes e impedem que eles causem lesões graves aos outros passageiros.",
        "não é obrigatório, mas é aconselhável.",
        "são da exclusiva responsabilidade dos ocupantes, já que num acidente seriam os únicos afectados.",
      ],
      correctAnswer: "podem salvar a vida aos seus ocupantes e impedem que eles causem lesões graves aos outros passageiros.",
      image: images.image119
    },
    {
      question: "O condutor que pretenda mudar de dirrecção para a esquerda deve:",
      options: [
        "Aproximar-se, com a necessária antecedência,da margem direita da faixa de rodagem e efectuar a manobra no trajecto mais curto.",
        "Aproximar-se, com a necessária antecedência,da margem esquerda da faixa de rodagem e efectuar a manobra no trajecto mais longo.",
        "Aproximar-se, com a necessária antecedência,da margem esquerda da faixa de rodagem e efectuar a manobra no trajecto mais curto.",
        "Aproximar-se, com a necessária antecedência,do eixo da via e efectuar a manobra no trajecto mais curto.",
      ],
      correctAnswer: "Aproximar-se, com a necessária antecedência,da margem esquerda da faixa de rodagem e efectuar a manobra no trajecto mais curto.",
      image: images.image120
    },
    {
      question: "O que indica o sinal?",
      options: [
        "Trânsito proibido a automóveis ligeiros de passageiros.",
        "Trânsito proibido à Táxis.",
        "Trânsito proibido a veículos automóveis e motociclos com carro."
      ],
      correctAnswer: "Trânsito proibido a veículos automóveis e motociclos com carro.",
      image: images.image121
    },
    {
      question: "A definição de parque de estacionamento é:",
      options: [
        "Local exclusivamente destinado ao estacionamento de veículos.",
        "Local exclusivamente destinado ao descanso dos condutores.",
        "Local exclusivamente destinado a manutenção e reparação dos veículos.",
        "Local exclusivamente destinado às cargas e descargas dos veículos.",
      ],
      correctAnswer: "Local exclusivamente destinado ao estacionamento de veículos.",
      image: images.image123
    },
    {
      question: "O que indica o sinal de interesse turístico?",
      options: [
        "Lugar histórico e genérico.",
        "Reserva florestal.",
        "Parque de campismo."
      ],
      correctAnswer: "Reserva florestal.",
      image: images.image122
    },
    {
      question: "Existe algum truque para conseguir eliminar o álcool do corpo do condutor, de uma forma mais rápida?",
      options: [
        "Sim, dormir um pouco.",
        "Sim, tomar doces.",
        "Não.",
        "Consumir alguma substância psicotrópica, como cannabis ou cocaína.",
      ],
      correctAnswer: "Não.",
      image: images.image124
    },
    {
      question: "Excepto o disposto em regulamentos locais e em caso de manifesta necessidade:",
      options: [
        "Pode utilizar-se o lado direito da faixa de rodagem para estacionar.",
        "Pode utilizar-se o lado direito da faixa de rodagem para a manobra de marcha atrás.",
        "Pode utilizar-se o lado direito da faixa de rodagem para conduzir a grande velocidade.",
        "Pode utilizar-se o lado direito da faixa de rodagem para ultrapassar ou mudar de direcção.",
      ],
      correctAnswer: "Pode utilizar-se o lado direito da faixa de rodagem para ultrapassar ou mudar de direcção.",
      image: images.image125
    },
    {
      question: "O que indica o sinal?",
      options: [
        "Ponte estrita.",
        "Passagem estreita.",
        "Entrocamentos sucessivos."
      ],
      correctAnswer: "Ponte estrita.",
      image: images.image126
    },
    {
      question: "Em épocas de nevoeiro (cacimba), deve manter:",
      options: [
        "Os vidros e os filtros de oléo sempre limpos.",
        "As escovas limpa-vidros funcionais, água no depósito do limpa pára-brisas e o aquecimento ou ar condicionado a ventilar contra o pára-brisas.",
        "O interior do veículo bem aquecido.",
        "As escovas limpa-vidros funcionais, água no depósito do limpa pára-brisas e o aquecimento ou ar condicionado desligados para não prejudicar o pára-brisas.",
      ],
      correctAnswer: "As escovas limpa-vidros funcionais, água no depósito do limpa pára-brisas e o aquecimento ou ar condicionado desligados para não prejudicar o pára-brisas.",
      image: images.image128
    },
    {
      question: "Que efeitos tem a fadiga na condução?",
      options: [
        "Melhora a atenção do condutor.",
        "Reduz o tempo de reacção do condutor.",
        "Reduz a capacidade de concentração e segurança.",
        "Diminui a sensibilidade ao encandeamento.",
      ],
      correctAnswer: "Reduz a capacidade de concentração e segurança.",
      image: images.image129
    },
    {
      question: "Qual é a função do cinto de segurança de um veículo?",
      options: [
        "Manter os ocupantes sentados na posição correcta.",
        "Permitir que os ocupantes se desloquem sobre o assento em caso de acidente.",
        "Reter e proteger os ocupantes numa colisão.",
        "Apenas impedir as lesões do condutor em caso de capotagem.",
      ],
      correctAnswer: "Reter e proteger os ocupantes numa colisão.",
      image: images.image127
    },
    {
      question: "O sinal indica?",
      options: [
        "Congestionamento de tráfego.",
        "Existência de controlo de tráfego adiante.",
        "Controlo policial por pirilampos."
      ],
      correctAnswer: "Controlo policial por pirilampos.",
      image: images.image131
        },
    {
      question: "Que veículo deve retroceder para dar passagem ao outro numa passagem estreita sem sinalização onde não seja possivel efectuar o cruzamento?",
      options: [
        "O veículo que está mais próximo do local em que o cruzamento seja possivel.",
        "O veículo mais pesado.",
        "O veículo com maior largura.",
        "O veículo que desce se for numa via de inclinação acentuada.",
      ],
      correctAnswer: "O veículo que está mais próximo do local em que o cruzamento seja possivel.",
      image: images.image132
    },
    {
      question: "Entende-se por visibilidade reduzida ou insuficiente, quando o condutor não possa avistar a faixa de rodagem em toda a sua largura numa extensão de:",
      options: [
        "Pelo menos, 200 metros.",
        "Pelo menos, 100 metros.",
        "Pelo menos, 50 metros.",
        "Pelo menos, 25 metros.",
      ],
      correctAnswer: "Pelo menos, 200 metros.",
      image: images.image133
    },

  ]
  ,
  6: [

    {
      question: "Uma das consequências de aumentar a velocidade, é que:",
      options: [
        "reduz as distrações.",
        "aumenta a gravidade das lesões em caso de acidente.",
        "melhora o tempo de reação.",
        "reduz a distância de travagem.",
      ],
      correctAnswer: "aumenta a gravidade das lesões em caso de acidente.",
      image: images.image134
    },

    {
      question: "Numa auto-estrada, pode-se inverter o sentido de marcha?",
      options: [
        "Sim, se a manobra for feita lentamente",
        "Sempre que possivel.",
        "Nunca."
      ],
      correctAnswer: "Nunca.",
      image: images.image135
    },

    {
      question: "O que indica o sinal?",
      options: [
        "Paragem obrigatória a veículos que transportam substâncias perigosas.",
        "Paragem proibida a veículos que transportam substâncias perigosas.",
        "Área reservada para transportam substâncias perigosas."
      ],
      correctAnswer: "Paragem proibida a veículos que transportam substâncias perigosas.",
      image: images.image136
    },

    {
      question: "O que comunica o condutor aos outros utentes da via?",
      options: [
        "Que vai reduzir a velocidade.",
        "Que vai voltar para o lado esquerdo do volante.",
        "Que vai voltar para o lado direito do volante."
      ],
      correctAnswer: "Que vai reduzir a velocidade.",
      image: images.image137
    },
    {
      question: "Os peões, para atravessar a faixa de rodagem...",
      options: [
        "podem fazê-lo sem utilizar as passagens para peões, se existe nenhuma a uma distância inferior a 10 m.",
        "devem certificar-se de que a distância e velocidade dos veículos, permite fazê-lo sem perigo de acidente.",
        "têm sempre prioridade de passagem.",
        "estão sempre obrigados a utilizar a passagem desnivelada para peões.",
      ],
      correctAnswer: "devem certificar-se de que a distância e velocidade dos veículos, permite fazê-lo sem perigo de acidente.",
      image: images.image138
    },
    {
      question: "Nos veículos de mercadorias, a carga deve ser disposta de modo a que:",
      options: [
        "Fique livre o maior espaço possivel à retaguarda da caixa de carga.",
        "O principal peso fique sobre o eixo da retaguarda.",
        "Seja assegurado o equilibrio do veículo, parado ou em movimento."
      ],
      correctAnswer: "Seja assegurado o equilibrio do veículo, parado ou em movimento.",
      image: images.image139
    },
    {
      question: "O que indica o sinal?",
      options: [
        "Trânsito proibido a peões, animais e veículos não automóveis.",
        "Trânsito proibido a animais e veículos não automóveis,",
        "Trânsito proibido a peões, animais e veículos automóveis."
      ],
      correctAnswer: "Trânsito proibido a peões, animais e veículos não automóveis.",
      image: images.image140
    },
    {
      question: "É proibido ultrapassar:",
      options: [
        "Nas estradas que só tenham uma via de trânsito para cada sentido.",
        "Imediatamente antes e nas passagens para peões.",
        "Em todas as curvas.",
        "Depois dos cruzamentos.",
      ],
      correctAnswer: "Imediatamente antes e nas passagens para peões.",
      image: images.image141
    },
    {
      question: "Os automóveis pesados de passageiros, fora das localidades, não devem exceder a velocidade instantânea de:",
      options: [
        "80 km/h",
        "100 km/h",
        "120 km/h"
      ],
      correctAnswer: "100 km/h",
      image: images.image142
    },
    {
      question: "Todos os condutores de veículos ou animais são obrigados a...",
      options: [
        "obedecer ao sinal de paragem feito pelas autoridades com competência para fiscalização do trânsito.",
        "abandonar os veículos nos locais de estacionamento sem motivo justificado.",
        "reduzir ou suspender intencionalmente a circulação, formando filas de trânsito desnecessárias.",
      ],
      correctAnswer: "obedecer ao sinal de paragem feito pelas autoridades com competência para fiscalização do trânsito.",
      image: images.image143
    },
    {
      question: "O que indica o sinal?",
      options: [
        "Sentido obrigatório para a frente.",
        "Via rápida.",
        "Existência de portagem na via em que segue."
      ],
      correctAnswer: "Existência de portagem na via em que segue.",
      image: images.image144
    },
    {
      question: "O que influencia a distância de reacção?",
      options: [
        "Estado do veículo e condições ambientais.",
        "Velocidade e estado da via.",
        "Tempo de reacção e velocidade.",
        "Condições do condutor e distância de travagem.",
      ],
      correctAnswer: "Tempo de reacção e velocidade.",
      image: images.image145
    },
    {
      question: "Considera-se ``condução defensiva´´?",
      options: [
        "Não efectuar manobras que possam colocar em perigo, independentemente dos outros condutores.",
        "Ajustar a velocidade e a trajectória de forma a evitar acidentes.",
        "Não ultrapassar os 30 km/h em zona urbana.",
        "Circular sempre a 40 km/h para evitar ser surpreendido por algum perigo.",
      ],
      correctAnswer: "Ajustar a velocidade e a trajectória de forma a evitar acidentes.",
      image: images.image146
    },
    {
      question: "O significado destes sinais é:",
      options: [
        "Saída com uma via de rodagem.",
        "Saída com uma estrada de um sentido.",
        "Saída com uma faixa de rodagem.",
        "Entrada com uma faixa de rodagem.",
      ],
      correctAnswer: "Saída com uma faixa de rodagem.",
      image: images.image147
    },
    {
      question: "Sempre que uma autoridade policial ou seus agentes, lhes façam sinal para isso, os condutores de veículos ou animais são obrigados a parar?",
      options: [
        "Sim, desde que estejam armados.",
        "Sim, sempre que exibam o sinal STOP.",
        "Não, nunca.",
        "Sim, desde que estejam devidamente uniformizados e identificados.",
      ],
      correctAnswer: "Sim, desde que estejam devidamente uniformizados e identificados.",
      image: images.image148
    },
    {
      question: "O socorrista, na avaliação do grau de consciência deve:",
      options: [
        "Abanar levemente a vítima ao nivel dos ombros e falar com ela, questionando se está a ouvir, está a sentir-se bem, onde está, como se chama, que dia é hoje...",
        "Ver os movimentos do tórax e do abdómen.",
        "Sentir o ar expirado, encostando a sua face ao nariz e boca da vítima."
      ],
      correctAnswer: "Abanar levemente a vítima ao nivel dos ombros e falar com ela, questionando se está a ouvir, está a sentir-se bem, onde está, como se chama, que dia é hoje...",
      image: images.image149
    },
    {
      question: "O espaço percorrido pelo veículo durante o tempo de reacção do condutor não é sempre o mesmo e depende:",
      options: [
        "Só na velocidade do veículo e não tem influência o tempo de reacção do condutor",
        "Do tempo da reacção e da velocidade do veículo.",
        "Só do tempo da reacção do condutor e não tem influência a velocidade do veículo.",
        "Principalmente de factores externos ao condutor.",
      ],
      correctAnswer: "Do tempo da reacção e da velocidade do veículo.",
      image: images.image150
    },
    {
      question: "Durante a noite, o condutor deve circular com:",
      options: [
        "Sempre com os médios ligados, utilizando os mínimios no cruzamento com outros veículos e os máximos quando não houver trânsito.",
        "É indiferente as luzes usadas desde que consiga ver bem a estrada.",
        "Sempre com os máximos ligados, utilizando os mínimios no cruzamento com outros veículos.",
        "Os médios ligados e utilizar os mãximos, quando não existir outro trânsito a circular à sua frente ou em sentido contrário.",
      ],
      correctAnswer: "Os médios ligados e utilizar os mãximos, quando não existir outro trânsito a circular à sua frente ou em sentido contrário.",
      image: images.image151
    },
    {
      question: "O estado emocional do condutor, é um factor de ordem interna, que influência:",
      options: [
        "O tempo de reacção e a distância de travagem.",
        "Apenas a distância de travagem.",
        "Apenas a distância de segurança."
      ],
      correctAnswer: "O tempo de reacção e a distância de travagem.",
      image: images.image152
    },
    {
      question: "Qual a antecedência mínima que a entidade que ordena a suspensão do trânsito nas estradas nacionais, deve anunciá-la ao público?",
      options: [
        "Um dia.",
        "Três dias.",
        "Quinze dias.",
        "Uma semana.",
      ],
      correctAnswer: "Três dias.",
      image: images.image153
    },
    {
      question: "A condução sob influência do álcool:",
      options: [
        "Em nada interfere com a segurança rodoviária.",
        "Diminui o risco de acidente.",
        "Aumenta o risco de acidente.",
        "Pode melhorar o estado do condutor devido à melhorar a sua disposição.",
      ],
      correctAnswer: "Aumenta o risco de acidente.",
      image: images.image154
    },
    {
      question: "Se o condutor sofre de uma doença, o que deve fazer para reduzir o risco de ter um acidente?",
      options: [
        "Imterromper a medicação que estiver a tomar,se tem que conduzir",
        "Deixar de conduzir em todos os casos",
        "Conhecer os efeitos secundários dos medicamentos",
        "Ignorar os sintomas para evitar distracções",
      ],
      correctAnswer: "Conhecer os efeitos secundários dos medicamentos",
      image: images.image155
    },
    {
      question: "Na via pública, a carga e descarga de um veículo deve ser feita:",
      options: [
        "Sempre pela direita.",
        "Sempre pela retaguarda.",
        "Sempre pela esquerda.",
        "Pela retaguarda ou pelo lado permitido para a paragem do veículo.",
      ],
      correctAnswer: "Pela retaguarda ou pelo lado permitido para a paragem do veículo.",
      image: images.image156
    },
    {
      question: "A razão pela qual não se deve retirar ou movimentar do interior dos veículos, as vítimas do acidentes é:",
      options: [
        "Para serem evitadas lesões crânio encefáticas, lesões da coluna cervical ou outras em órgãos internos ou ossos fracturados.",
        "Para não contaminar o local do acidente.",
        "Para não passar doenças a quem socorre."
      ],
      correctAnswer: "Para serem evitadas lesões crânio encefáticas, lesões da coluna cervical ou outras em órgãos internos ou ossos fracturados.",
      image: images.image157
    },
    {
      question: "Com relação aos acidentados, qual a ordem pela qual devem ser postos em prática os três príncipios de actuação?",
      options: [
        "Socorrer, Alertar e Prevenir.",
        "Alertar, Socorrer e Prevenir.",
        "Prevenir, Alertar e Socorrer."
      ],
      correctAnswer: "Prevenir, Alertar e Socorrer.",
      image: images.image158
    },

  ],

  7: [

    {
      question: "Quem não teve uma boa noite de descanso:",
      options: [
        "Mais facilmente se torna vítima de estados de fadiga.",
        "Deve beber muita água durante o dia enquanto conduz.",
        "Deve tomar mais cafés durante o dia enquanto conduz.",
        "Não afecta a sua capacidade de condução.",
      ],
      correctAnswer: "Mais facilmente se torna vítima de estados de fadiga.",
      image: images.image159
    },

    {
      question: "O estado de alerta do condutor, é influenciado pela fadiga, afectando a forma como:",
      options: [
        "O veículo se comporta no ambiente rodoviário.",
        "O condutor recolhe as informações relevantes do ambiente rodoviário.",
        "O condutor realiza a manobra de ultrapassagem."
      ],
      correctAnswer: "O condutor recolhe as informações relevantes do ambiente rodoviário.",
      image: images.image160
    },

    {
      question: "A definição de pista especial é:",
      options: [
        "Via privada especialmente destinada, de acordo com sinalização, ao trânsito de peões, de animais ou certa espécie de veículos.",
        "Via privada especialmente destinada, de acordo com sinalização, ao trânsito de veículos automóveis.",
        "Via pública especialmente destinada, de acordo com sinalização, ao trânsito de peões, de animais ou certa espécie de veículos.",
        "Via pública especialmente destinada ao trânsito de veículos de polícia.",
      ],
      correctAnswer: "Via pública especialmente destinada, de acordo com sinalização, ao trânsito de peões, de animais ou certa espécie de veículos.",
      image: images.image161
    },

    {
      question: "Em caso de nevoeiro (cacimba) os 4 piscas ou luzes de emergência, só devem ser utilizados:",
      options: [
        "Quando o véiculo circular a uma velocidade moderada.",
        "Sempre que mudar de direcção ou iniciar uma ultrapassagem.",
        "Devem ser usadas sempre.",
        "Se o veículo estiver imobilizado, a circular a velocidades muito baixas ou quando fizer uma travagem forte e repentina.",
      ],
      correctAnswer: "Se o veículo estiver imobilizado, a circular a velocidades muito baixas ou quando fizer uma travagem forte e repentina.",
      image: images.image162
    },
    {
      question: "Nas pontes, túneis e passagens de nível:",
      options: [
        "Os animais atrelados ou não, devem seguir passo.",
        "Os animais só quando estiverem atrelados, devem seguir passo.",
        "Os animais quando não atrelados, devem seguir a passo de corrida,",
        "Os animais atrelados ou não, devem seguir a passo de corrida.",
      ],
      correctAnswer: "Os animais atrelados ou não, devem seguir passo.",
      image: images.image163
    },
    {
      question: "Para não causar perigo e pôr em causa a segurança das pessoas e das coisas, os condutores devem...",
      options: [
        "circular nos limites máximos de velocidade das estradas.",
        "regular a velocidade atendendo às caracteristicas do veículo, às condições da via e ao estado do condutor.",
        "circular abaixo dos limites mínimos de velocidade.",
        "ficar em ponto morto nas descidas muito inclinadas.",
      ],
      correctAnswer: "regular a velocidade atendendo às caracteristicas do veículo, às condições da via e ao estado do condutor.",
      image: images.image164
    },
    {
      question: "O que deve fazer o condutor se a fila da esquerda estiver a circular mais rapidamente?",
      options: [
        "Sinalizar e mudar de fila de trânsito.",
        "Mudar de fila de trânsito.",
        "Manter-se na fila de trânsito em que se encontra."
      ],
      correctAnswer: "Manter-se na fila de trânsito em que se encontra.",
      image: images.image165
    },
    {
      question: "Perante a luz verde, não deve avançar:",
      options: [
        "Quando pela intensidade de trânsito, seja previsível a imobilização no centro da intersecção.",
        "Quando no passeio existam peões que pretendam iniciar a travessia da faixa de rodagem.",
        "Quando um agente regular de trânsito se encontre nas proximidades."
      ],
      correctAnswer: "Quando pela intensidade de trânsito, seja previsível a imobilização no centro da intersecção.",
      image: images.image166
    },
    {
      question: "O planeamento de velocidade e da trajectória do veículo assenta:",
      options: [
        "Nas motivações e necessidades do condutor sem influência da informação que ele recebe do exterior.",
        "Nas motivações e necessidades do condutor e também na informação que ele recebe do exterior.",
        "Na informação que ele recebe do exterior."
      ],
      correctAnswer: "Nas motivações e necessidades do condutor e também na informação que ele recebe do exterior.",
      image: images.image167
    },
    {
      question: "A definição de plataforma é:",
      options: [
        "Parte das arestas externas das valetas laterais da estrada.",
        "Parte das arestas internas das valetas laterais da estrada.",
        "Parte das valetas laterais da estrada.",
        "O conjunto de estrada e bermas.",
      ],
      correctAnswer: "Parte das arestas internas das valetas laterais da estrada.",
      image: images.image168
    },
    {
      question: "O agente de trânsito que aparece na fotografia, manda:",
      options: [
        "Parar o tráfego que venha da esquerda.",
        "Avançar o tráfego que venha da retaguarda.",
        "Avançar o tráfego que venha da esquerda."
      ],
      correctAnswer: "Avançar o tráfego que venha da esquerda.",
      image: images.image169
    },
    {
      question: "O significado deste sinal é:",
      options: [
        "Via temporariamente interrompida.",
        "Via temporariamente interrompida, mas pode seguir em frente.",
        "Via definitivamente interrompida.",
        "Via temporariamente interrompida, só durante a noite.",
      ],
      correctAnswer: "Via temporariamente interrompida.",
      image: images.image170
    },
    {
      question: "O sinal luminoso cm a seta verde indica:",
      options: [
        "Acesso ou passagem condicionado.",
        "Acesso ou passagem interdito.",
        "Acesso ou passagem autorizado.",
      ],
      correctAnswer: "Acesso ou passagem autorizado.",
      image: images.image171
    },
    {
      question: "Os automóveis ligeiros de passageiros, devem estar equipados com sinais de pré-sinalização de perigo?",
      options: [
        "Sim, apenas são obrigatórios dois triangulos de pré-sinalização de perigo.",
        "Sim, dois triangulos de pré-sinalização de perigo e um colete reflector.",
        "Não.",
        "Sim, um colete reflector e um triangulo de pré-sinalização de perigo.",
      ],
      correctAnswer: "Sim, dois triangulos de pré-sinalização de perigo e um colete reflector.",
      image: images.image172
    },
    {
      question: "A condução urbana, caracteriza-se essencialmente:",
      options: [
        "Pela abundância de sinais luminosos.",
        "Pela ausência de regras de trânsito.",
        "Por uma grande intensidade de trânsito.",
        "Pela pouca presença de peões.",
      ],
      correctAnswer: "Por uma grande intensidade de trânsito.",
      image: images.image173
    },
    {
      question: "Num veículo equipado com motor Diesel em aceleração, a libertação de muito fumo negro pelo tubo de escape, significa:",
      options: [
        "Óptima qualidade do combustível.",
        "Que o veículo está a queimar muito oléo.",
        "Que o veículo acelera bem.",
        "Necessidade de regulação da bomba injectora.",
      ],
      correctAnswer: "Necessidade de regulação da bomba injectora.",
      image: images.image174
    },
    {
      question: "O significado deste sinal é:",
      options: [
        "Entroncamento agudo da esquerda.",
        "Entroncamento convergente da esquerda.",
        "Entroncamento divergente da esquerda.",
        "Entroncamento agudo da direita.",
      ],
      correctAnswer: "Entroncamento agudo da esquerda.",
      image: images.image175
    },
    {
      question: "O significado deste sinal é:",
      options: [
        "Travessia de peões.",
        "Travessia de idosos.",
        "Travessia de crianças.",
        "Passagem de peões.",
      ],
      correctAnswer: "Travessia de peões.",
      image: images.image176
    },
    {
      question: "Qual dos veículos tem prioridade de passagem nesta situação?",
      options: [
        "O veículo vermelho.",
        "O veículo amarelo.",
        "O primeiro que chegar ao cruzamento."
      ],
      correctAnswer: "O veículo amarelo.",
      image: images.image177
    },
    {
      question: "O que indica o sinal?",
      options: [
        "Sinalização luminosa.",
        "Passagem de nível.",
        "Sinalização luminosa em manutenção."
      ],
      correctAnswer: "Sinalização luminosa em manutenção.",
      image: images.image178
    },
    {
      question: "Que veículo deve retroceder para dar passagem ao outro numa passagem estreita sem sinalização onde não seja possivel efectuar o cruzamento?",
      options: [
        "O veículo mais pesado.",
        "O veículo com maior largura.",
        "O veículo que está mais próximo do local em que o cruzamento seja possivel.",
        "O veículo que desce se for numa via de inclinação acentuada.",
      ],
      correctAnswer: "O veículo que está mais próximo do local em que o cruzamento seja possivel.",
      image: images.image179
    },
    {
      question: "Quando os peões transitem na faixa de rodagem, devem fazê-lo...",
      options: [
        "numa única fila, sempre que as condições de visibilidade ou a intesidade do trânsito o aconselhem.",
        "a par, quando transitem desde o anoitecer ao amanhecer.",
        "pela esquerda da faixa de rodagem, em relação ao seu sentido de marcha.",
        "a par, quando transitem em condções de visibilidade insuficiente.",
      ],
      correctAnswer: "numa única fila, sempre que as condições de visibilidade ou a intesidade do trânsito o aconselhem.",
      image: images.image180
    },
    {
      question: "Os condutores com pouco tempo de condução (inexperientes):",
      options: [
        "As capacidades na recolha da informação não tem relação com experiência, sim com a visão.",
        "Têm capacidades mais acertadas na recolha de informações.",
        "Têm capacidade menos eficientes na recolha de informações.",
        "Têm capacidades mais eficientes na recolha de informações.",
      ],
      correctAnswer: "Têm capacidade menos eficientes na recolha de informações.",
      image: images.image181
    },
    {
      question: "Para praricar uma condução defensiva a antecipação é um comportamento importante.",
      options: [
        "Só nas passagens para peões.",
        "Errado.",
        "Certo.",
      ],
      correctAnswer: "",
      image: images.image182
    },
    {
      question: "Os automóveis ligeiros de passageiros e mistos sem reboque, fora das localidades, não devem exceder a velocidade instantânea de:",
      options: [
        "140 km/h.",
        "120 km/h.",
        "100 km/h.",
        "80 km/h.",
      ],
      correctAnswer: "120 km/h.",
      image: images.image183
    },

  ],

  8: [

    {
      question: "O que indica o sinal?",
      options: [
        "Paragem obrigatória em três vias.",
        "Paragem obrigatória.",
        "Paragem obrigatória a três metros."
      ],
      correctAnswer: "Paragem obrigatória em três vias.",
      image: images.image184
    },

    {
      question: "Nos sias quentes, é recomendável...",
      options: [
        "fazer menos descansos durante uma viagem, para chegar ao destino o mais rapidamente possível.",
        "evitar conduzir com o ar condicionado ligado.",
        "efectuar mais descansos durante uma viagem, porque a fadiga e o sono aparecem mais facilmente.",
        "evitar tomar bebidas como água ou sumos naturais.",
      ],
      correctAnswer: "efectuar mais descansos durante uma viagem, porque a fadiga e o sono aparecem mais facilmente.",
      image: images.image185
    },

    {
      question: "O sinal de cor amarela e preta, indica:",
      options: [
        "Baia indicadora de separador físico.",
        "Baia limitadora de altura.",
        "Barricada."
      ],
      correctAnswer: "Baia limitadora de altura.",
      image: images.image186
    },

    {
      question: "O que indica o sinal?",
      options: [
        "Pista obrigatória para peões",
        "Pista obrigatória para veículos de tracção manual.",
        "Trânsito proibido a velocípedes e peões.",
        "Pista obrigatória para peões e velocípedes.",
      ],
      correctAnswer: "Pista obrigatória para peões e velocípedes.",
      image: images.image187
    },
    {
      question: "Ao aproximar-se de qualquer tipo de intersecção, o condutor do veículo deve:",
      options: [
        "Demostrar prudência especial, circulando em alta velocidade de forma que possa passar o mais rapidamente possível.",
        "Demostrar prudência especial, circulando à velocidade de 30Km/h, para que possa travar o seu veículo para dar passagem a animais que transitem na via.",
        "Demostrar prudência especial, circulando à velocidade moderada para que possa deter o seu veículo com segurança, para dar passagem ao peão e a veículos que tenha o direito de preferência.",
        "Demostrar prudência especial, circulando à velocidade de 20Km/h, para que possa travar o seu veículo para dar passagem a animais que transitem na via.",
      ],
      correctAnswer: "Demostrar prudência especial, circulando à velocidade moderada para que possa deter o seu veículo com segurança, para dar passagem ao peão e a veículos que tenha o direito de preferência.",
      image: images.image188
    },
    {
      question: "A definição de localidade é:",
      options: [
        "Zona regional cujos limites são sinalizados com sinalização luminosa.",
        "Zona com edificações cujos limites não são sinalizados.",
        "Zona com edificações cujos limites são devidamente sinalizados.",
        "Zona urbana cujos limites, não são sinalizados.",
      ],
      correctAnswer: "Zona com edificações cujos limites são devidamente sinalizados.",
      image: images.image189
    },
    {
      question: "Como medida defensiva, o condutor deve:",
      options: [
        "Circular com óculos escuros para evitar encadeamento.",
        "Dar a conhecer as suas intenções através de sinalização.",
        "Parar sempre que se aproxime de um cruzamento para evitar um acidente.",
        "Deve usar sempre a buzina para alertar outros utentes da via da sua presença.",
      ],
      correctAnswer: "Dar a conhecer as suas intenções através de sinalização.",
      image: images.image190
    },
    {
      question: "Quem exceder de 30Km/h a 60Km/h de velocidade (automóveis ligeiros e motociclos) os limites, fora das localidades é punido:",
      options: [
        "Com multa de 2.000,00 Mt e contravenção leve.",
        "Com multa de 2.000,00 Mt e contravenção grave.",
        "Com multa de 2.000,00 Mt e contravenção média.",
        "Com multa de 3.000,00 Mt e contravenção média.",
      ],
      correctAnswer: "Com multa de 2.000,00 Mt e contravenção média.",
      image: images.image191
    },
    {
      question: "Circular com o braço fora do veículo:",
      options: [
        "É uma contravenção punida com multa de 500,00 Mt.",
        "É uma contravenção punida com multa de 1.000,00 Mt.",
        "É uma contravenção punida com multa de 2.000,00 Mt.",
        "É uma contravenção punida com multa de 3.000,00 Mt.",
      ],
      correctAnswer: "É uma contravenção punida com multa de 1.000,00 Mt.",
      image: images.image192
    },
    {
      question: "Podem ser submetidos às provas para a detecção de álcool ou substâncias estupefacientes ou psicotrópicas:",
      options: [
        "Apenas os condutores de veículos automóveis.",
        "Os peões, sempre que sejam intervenientes em acidentes de trânsito e os condutores.",
        "Todos os condutores e peões que transitem pela via pública,",
        "Só os condutores que sejam intervenientes em acidentes de trânsito.",
      ],
      correctAnswer: "Os peões, sempre que sejam intervenientes em acidentes de trânsito e os condutores.",
      image: images.image193
    },
    {
      question: "Depois de ter tomado bebidas alcoólicas:",
      options: [
        "O álcool entra directamente no sistema urinário.",
        "O álcool entra rapidamente no sistema circulatório.",
        "O álcool demora duas horas a entrar no sistema circulatório."
      ],
      correctAnswer: "O álcool entra rapidamente no sistema circulatório.",
      image: images.image194
    },
    {
      question: "Assinale a afirmação falsa:",
      options: [
        "A perda momentânea da visão designada por encadeamento, é sempre resultado do cruzamento com um veículo em sentido contrário e com as luzes de estrada ligadas.",
        "Durante a condução nocturna, a visão cromática é afextada o que afecta a identificação dos obstáculos.",
        "Apesar da menor intesidade de trânsito, a gravidade dos acidentes rodoviários verificados durante a noite é normalmente maior.",
        "Nos períodos de aurora (nascer do dia) e crepúsculo (por-do-sol), é mais dificil avaliar as distâncias, bem como distinguir as formas e as cores dos obstáculos.",
      ],
      correctAnswer: "A perda momentânea da visão designada por encadeamento, é sempre resultado do cruzamento com um veículo em sentido contrário e com as luzes de estrada ligadas.",
      image: images.image195
    },
    {
      question: "O que pode ser favorecido se tiver a suspensão em bom estado?",
      options: [
        "A redução da distância de reacção.",
        "A redução da distância de travagem.",
        "O aumento das distâncias de marcha.",
        "A redução da atenção do condutor.",
      ],
      correctAnswer: "A redução da distância de travagem.",
      image: images.image196
    },
    {
      question: "Consideram-se veículos prioritários:",
      options: [
        "As ambulâncias e veículos da polícia;",
        "Só os transitam em missão urgente de socorro e comitivas governamentais, mesmo não assinalando adequadamente a sua marcha.",
        "Os que transitam em missão urgente de socorro e comitivas governamentais, assinalando adequandamente a sua marcha.",
        "Apenas as comitivas governamentais.",
      ],
      correctAnswer: "Os que transitam em missão urgente de socorro e comitivas governamentais, assinalando adequandamente a sua marcha.",
      image: images.image197
    },
    {
      question: "Mudança de direcção é uma manobra em que:",
      options: [
        "Um condutor toma outra via que se intersecta com aquela em que vinha circulando.",
        "Um condutor toma outra via que é paralela aquela em que vinha circulando.",
        "Um condutor toma outra faixa de sentido contrário aquela em que vinha circulando.",
        "Um condutor faz invasão de sentido de marcha.",
      ],
      correctAnswer: "Um condutor toma outra via que se intersecta com aquela em que vinha circulando.",
      image: images.image198
    },
    {
      question: "A deslocação do ar causado pela passagem de veículos pesados em alta velocidade:",
      options: [
        "Provoca ventos frontais que afectam os veículos ligeiros mais leves.",
        "Provoca ventos laterais que afectam, sobretudo os veículos pesados de passageiros.",
        "Provoca ventos laterais que afectam os veículos ligeiros mais leves.",
        "Não tem influência para os outros condutores.",
      ],
      correctAnswer: "Provoca ventos laterais que afectam os veículos ligeiros mais leves.",
      image: images.image199
    },
    {
      question: "A definição de multa é:",
      options: [
        "Sanção pecuniária destinada a punir a prática de uma contravenção ao Código de Estrada.",
        "Condenação dada a um indivíduo que infringiu uma norma estabelecida na legislação.",
        "Condenação disciplinar.",
        "Condenação administrativa.",
      ],
      correctAnswer: "Sanção pecuniária destinada a punir a prática de uma contravenção ao Código de Estrada.",
      image: images.image200
    },
    {
      question: "O condutor de veículo utilizado no transporte colectivo de passageiros, só pode parar nas faixas de rodagem para:",
      options: [
        "A entrada e saída de passageiros nos locais especialmente destinados a esse fim.",
        "Carregar e descarregar mercadorias, só durante o dia.",
        "Carregar e descarregar mercadorias, só durante o a noite.",
        "A entrada e saída de passageiros, em qualquer lugar que lhe dê mais jeito.",
      ],
      correctAnswer: "A entrada e saída de passageiros nos locais especialmente destinados a esse fim.",
      image: images.image201
    },
    {
      question: "No caso de passar por um acidente, é obrigado a parar para dar assistência?",
      options: [
        "Sim, porque se não der o alerta pode incorrer no crime de omissão de auxílio.",
        "Não, mas não dar o alerta pode incorrer no crime de omissão de auxílio.",
        "Sim, sempre."
      ],
      correctAnswer: "Sim, porque se não der o alerta pode incorrer no crime de omissão de auxílio.",
      image: images.image202
    },
    {
      question: "A definição de auto-estrada é:",
      options: [
        "Via pública destinada a trânsito lento, com separação física de faixas de rodagem, sem cruzamentos de nível nem acesso a propriedades marginais, com acessos condicionados e sinalizada como tal.",
        "Via pública destinada a trânsito rápido, sem separação física de faixas de rodagem, sem cruzamentos de nível com acesso a propriedades marginais, com acessos condicionados e sinalizada como tal.",
        "Via pública destinada a trânsito rápido, com separação física de faixas de rodagem, sem cruzamentos de nível nem acesso a propriedades marginais, com acessos condicionados e sinalizada como tal.",
        "Via pública destinada a trânsito rápido, com separação física de faixas de rodagem, com cruzamentos de nível com acesso a propriedades marginais, com acessos condicionados e sinalizada como tal.",
      ],
      correctAnswer: "Via pública destinada a trânsito rápido, com separação física de faixas de rodagem, sem cruzamentos de nível nem acesso a propriedades marginais, com acessos condicionados e sinalizada como tal.",
      image: images.image203
    },
    {
      question: "A definição de passeio é:",
      options: [
        "Parte que ladeia a faixa de rodagem, destinada exclusivamente ao trânsito de veículos.",
        "Parte que ladeia a faixa de rodagem, destinada ao estacionamento de veículos.",
        "Parte que ladeia a faixa de rodagem, destinada exclusivamente ao trânsito de peões.",
        "Parte da faixa de rodagem, destinada exclusivamente ao trânsito de peões.",
      ],
      correctAnswer: "Parte que ladeia a faixa de rodagem, destinada exclusivamente ao trânsito de peões.",
      image: images.image204
    },
    {
      question: "Quem exceder em mais de 60 Km/h de velocidade (automóveis ligeiros e motociclos) os limites, fora das localidades é punido:",
      options: [
        "Com multa de 6.000,00 Mt e contravenção grave.",
        "Com multa de 8.000,00 Mt e contravenção média.",
        "Com multa de 8.000,00 Mt e contravenção leve.",
        "Com multa de 8.000,00 Mt e contravenção grave.",
      ],
      correctAnswer: "Com multa de 8.000,00 Mt e contravenção grave.",
      image: images.image205
    },
    {
      question: "O condutor está sujeito ao aparecimento de fadiga, quando circula com trânsito intenso?",
      options: [
        "Não está porque circula a velocidade reduzida.",
        "Não está porque nesta situação pode descansar devido à pouca velocidade do trânsito.",
        "Está porque é uma situação de trânsito monótona o que provoca fadiga.",
        "Está e para evitar a fadiga deve beber café e bebidas estimulantes.",
      ],
      correctAnswer: "Está porque é uma situação de trânsito monótona o que provoca fadiga.",
      image: images.image206
    },
    {
      question: "Todo o condutor de veículos ou de animais é obrigado:",
      options: [
        "Sempre que não haja obstáculos que o impeça, a facilitar imediatamente a ultrapassagem desviando-se o mais possível para a direita e não aumentar a sua velocidade enquanto não for ultrapassado.",
        "Sempre que não haja obstáculos que o impeça, a facilitar imediatamente a ultrapassagem desviando-se o mais possível para a esquerda e não aumentar a sua velocidade enquanto não for ultrapassado.",
        "Sempre que não haja obstáculos que o impeça, a facilitar imediatamente a ultrapassagem desviando-se o mais possível para a esquerda e aumentar a sua velocidade enquanto não for ultrapassado.",
        "Sempre que não haja obstáculos que o impeça, a facilitar imediatamente a ultrapassagem desviando-se o mais possível para o eixo da via e não aumentar a sua velocidade enquanto não for ultrapassado.",
      ],
      correctAnswer: "Sempre que não haja obstáculos que o impeça, a facilitar imediatamente a ultrapassagem desviando-se o mais possível para a esquerda e não aumentar a sua velocidade enquanto não for ultrapassado.",
      image: images.image207
    },
    {
      question: "Quando os veículos transitem com as luzes acesas por falta de luminosidade:",
      options: [
        "Os sinais sonoros não podem ser substituídos por sinais luminosos dos faróis do veículo.",
        "É obrigatória a substituição por sinais luminosos dos faróis do veículo usados intermitentemente e por forma a não causar encadeamento.",
        "Os sinais sonoros podem ser substituídos por sinais luminosos dos faróis do veículo usados intermitentemente e por forma a não causar encadeamento.",
        "Os sinais sonoros podem ser substituídos por sinais luminosos dos faróis do veículo usando as luzes de máximos.",
      ],
      correctAnswer: "Os sinais sonoros podem ser substituídos por sinais luminosos dos faróis do veículo usados intermitentemente e por forma a não causar encadeamento.",
      image: images.image208
    },
  ],

    9: [

      {
        question: "Quando os veículos transitam com as luzes acessas por falta de luminosidade:",
        options: [
          "Os sinais sonoros não podem ser substituídos por sinais luminosos dos faróis do veículo.",
          "É obrigatória a substituíção por sinais luminosos dos faróis do veículo usados intermitentemente e por forma a não causar encandeamento.",
          "Os sinais sonoros podem ser substituídos por sinais luminosos dos faróis do veículo usados intermitentemente e por forma a não causar encandeamento.",
          "Os sinais sonoros podem ser substituídos por sinais luminosos dos faróis do veículo usando as luzes de máximos.",
        ],
        correctAnswer: "Os sinais sonoros podem ser substituídos por sinais luminosos dos faróis do veículo usados intermitentemente e por forma a não causar encandeamento.",
        image: images.image208
      },
  
      {
        question: "O que deve fazer o condutor perante a marca rodoviária de cor branca?",
        options: [
          "Circular à sua esquerda, quando a linha fizer a separação de sentido de trânsito.",
          "Pisar ou transpor a linha.",
          "Abrandar a marcha."
        ],
        correctAnswer: "Circular à sua esquerda, quando a linha fizer a separação de sentido de trânsito.",
        image: images.image210
      },
  
      {
        question: "Em acidente de viação com vitima, deixar de prestar ou providenciar socorro, constitui contravenção:",
        options: [
          "Leve.",
          "Média.",
          "Grave."
        ],
        correctAnswer: "Grave.",
        image: images.image211
      },
  
      {
        question: "O que indica o sinal?",
        options: [
          "Fim da fila de trânsito à esquerda.",
          "Fim da fila de trânsito à direita.",
          "Convergência de filas de trânsito."
        ],
        correctAnswer: "Convergência de filas de trânsito.",
        image: images.image212
      },
      {
        question: "Nos locais onde é proibido, a inversão do sentido de marcha:",
        options: [
          "É contravenção punida com multa de 500,00 mt.",
          "É contravenção punida com multa de 1.000,00 mt.",
          "É contravenção punida com multa de 2.000,00 mt.",
          "Não é considerada contravenção.",
        ],
        correctAnswer: "É contravenção punida com multa de 1.000,00 mt.",
        image: images.image213
      },
      {
        question: "O que é a força centrífuga?",
        options: [
          "É a força aparente que `empurra´ os veículos para o interior das curvas;",
          "É a força aparente que `empurra´ os veículos para o exterior das curvas.",
          "É a força aparente que trava os veículos nas curvas.",
          "Uma força que só ocorre quando o veículo vai em linha recta.",
        ],
        correctAnswer: "É a força aparente que `empurra´ os veículos para o exterior das curvas.",
        image: images.image214
      },
      {
        question: "Para conduzir com segurança, deve moderar especialmente a velocidade...",
        options: [
          "só nas pontes, túneis e passagem de nível.",
          "nos cruzamentos e entroncamentos nos que tenha prioridade de passagem.",
          "nas curvas, lombas e outros locais de visibilidade reduzida.",
          "nos locais assinalados com sinais de obrigação.",
        ],
        correctAnswer: "nas curvas, lombas e outros locais de visibilidade reduzida.",
        image: images.image215
      },
      {
        question: "Na condução nocturna, os hábitos do condutor aumentam ou não a fadiga?",
        options: [
          "Factores como alimentação, seu tipo, quantidade e frequência.",
          "Sim, factores como alimentação, seu tipo, quantidade e frequência.",
          "Apenas a ingestão de bebidas alcoólicas acentuam a fadiga.",
          "Os hábitos do condutor não aumentam a fadiga.",
        ],
        correctAnswer: "Sim, factores como alimentação, seu tipo, quantidade e frequência.",
        image: images.image216
      },
      {
        question: "A definição de berma é:",
        options: [
          "Superficie de via pública especialmente destinada ao trânsito de veículos e que ladeia a faixa de rodagem;",
          "Superficie de via pública não especialmente destinada ao trânsito de veículos e que ladeia a faixa de rodagem;",
          "Superficie de via pública destinada ao trânsito de veículos e que ladeia a faixa de rodagem;",
          "Superficie de via pública especialmente destinada ao trânsito de automóveis e que ladeia a faixa de rodagem;",
        ],
        correctAnswer: "Superficie de via pública não especialmente destinada ao trânsito de veículos e que ladeia a faixa de rodagem;",
        image: images.image217
      },
      {
        question: "Quando os pneus têm uma pressão incorrecta:",
        options: [
          "Desgastam-se mais e correm maior risco de rebentar.",
          "Desgastam-se menos e correm menos risco de rebentar.",
          "Consome-se menos combustível.",
          "Melhora a estabilidade do veículo e o seu conforto.",
        ],
        correctAnswer: "Desgastam-se mais e correm maior risco de rebentar.",
        image: images.image218
      },
      {
        question: "O uso do capacete para proteger a cabeça...",
        options: [
          "é recomendável para os condutores e passageiros de motociclos, mas não é obrigatório.",
          "é obrigatório para os condutores e passageiros de motociclos e ciclomotores.",
          "só é obrigatório para os condutores e passageiros de motociclos.",
          "não é eficaz em caso de acidente.",
        ],
        correctAnswer: "é obrigatório para os condutores e passageiros de motociclos e ciclomotores.",
        image: images.image219
      },
      {
        question: "O significado deste sinal é:",
        options: [
          "Zona onde só podem passar três carros de cada vez.",
          "Zona de estacionamento em fila.",
          "Congestionamento de tráfego.",
          "Zona de paragem em fila.",
        ],
        correctAnswer: "Congestionamento de tráfego.",
        image: images.image220
      },
      {
        question: "Que indica a marca rodoviária?",
        options: [
          "Linha de paragem obrigatória com stop.",
          "Linha de paragem obrigatória.",
          "Linha de cedência de prioridade com símbolo triangular."
        ],
        correctAnswer: "Linha de cedência de prioridade com símbolo triangular.",
        image: images.image221
      },
      {
        question: "O que indica o sinal circular?",
        options: [
          "Transito proibido para todos os veículos automóveis.",
          "Proibição de ultrapassagem para motociclos simples.",
          "Proibição de ultrapassagem para automóveis ligeiros.",
        ],
        correctAnswer: "Proibição de ultrapassagem para motociclos simples.",
        image: images.image222
      },
      {
        question: "Qual é a validade que tem a carta de condução de categoria B?",
        options: [
          "Dois anos.",
          "Três anos.",
          "Cinco anos.",
          "Dez anos.",
        ],
        correctAnswer: "Cinco anos.",
        image: images.image223
      },
      {
        question: "A recolha da informação é influenciada pela fadiga?",
        options: [
          "Não.",
          "Sim, mas apenas em condução urbana.",
          "Sim, assim como influencia toda a tarefa da condução.",
          "Não, a menos que o condutor esteja muito cansado.",
        ],
        correctAnswer: "Sim, assim como influencia toda a tarefa da condução.",
        image: images.image224
      },
      {
        question: "Que deve fazer perante um ferido que tenha uma forte hemorragia na perna?",
        options: [
          "Pôr pomada na ferida.",
          "Cobrir a ferida e levantar-lhe a perna para reduzir a hemorragia.",
          "Deve sempre fazer um torniquete na perna lesionada."
        ],
        correctAnswer: "Cobrir a ferida e levantar-lhe a perna para reduzir a hemorragia.",
        image: images.image225
      },
      {
        question: "Factores de risco serão:",
        options: [
          "Todos os elementos externos a um veículo que possam provocar riscos na pintura.",
          "Todas as marcas rodoviárias que contenham riscos.",
          "Todos os factores que aumentem o rísco de acidente.",
          "Todos os factores externos ao condutor.",
        ],
        correctAnswer: "Todos os factores que aumentem o rísco de acidente.",
        image: images.image226
      },
      {
        question: "Sempre que no mesmo sentido sejam possíveis duas ou mais filas de trânsito:",
        options: [
          "O condutor deve circular pela via de trânsito mais à direita, podendo utilizar-se outra se não houver lugar naquela, e para ultrapassar ou mudar de direcção.",
          "O condutor deve circular pela via de trânsito mais à esquerda, podendo utilizar-se outra se não houver lugar naquela, e para ultrapassar ou mudar de direcção.",
          "O condutor deve circular pela via de trânsito mais à esquerda, podendo utilizar-se outra se não houver lugar naquela, e para estacionar.",
          "O condutor deve circular pela via de trânsito mais à direita, podendo utilizar-se outra, para ultrapassar ou mudar de direcção.",
        ],
        correctAnswer: "O condutor deve circular pela via de trânsito mais à esquerda, podendo utilizar-se outra se não houver lugar naquela, e para ultrapassar ou mudar de direcção.",
        image: images.image227
      },
      {
        question: "O que indica o sinal?",
        options: [
          "Área reservada para autocarros e autocarros médios.",
          "Parque de estacionamento para autocarros e autocarros médios.",
          "Faixa reservada para qualquer tipo de autocarro do lado esquerdo."
        ],
        correctAnswer: "Área reservada para autocarros e autocarros médios.",
        image: images.image228
      },
      {
        question: "Pode uma criança com idade inferior a 3 anos viajar no banco da frente do automóvel?",
        options: [
          "Sim, sempre que utilize o cinto de segurança.",
          "Não, em caso algum.",
          "Sim, utilizando um sistema de retenção virado para a retaguarda e com almofada de ar frontal (airbag) do lado do passageiro desactivado.",
          "Sim, quando o automóvel não tiver cinto de segurança.",  
        ],
        correctAnswer: "Sim, utilizando um sistema de retenção virado para a retaguarda e com almofada de ar frontal (airbag) do lado do passageiro desactivado.",
        image: images.image229
      },
      {
        question: "Pode conduzir um automóvel ligeiro com reboque com a carta de condução de categoria B?",
        options: [
          "Sim, desde que o peso bruto do reboque não exceda 750Kg.",
          "Não, é necessário ter a carta de condução de categoria C1E.",
          "Sim, desde que o peso bruto do reboque não exceda 3500Kg.",
          "Não, é necessário ter a carta de condução de categoria G.",
        ],
        correctAnswer: "Sim, desde que o peso bruto do reboque não exceda 750Kg.",
        image: images.image230
      },
      {
        question: "O facto de conduzir de noite, deve ter influência na velocidade a que segue?",
        options: [
          "Não, porque a utilização de luzes é obrigatória.",
          "Sim, mas apenas dentro das localidades.",
          "Sim.",
          "Não, se conheço bem a estrada.",
        ],
        correctAnswer: "Sim.",
        image: images.image231
      },
      {
        question: "Exploração perceptiva é:",
        options: [
          "Procedimentos do condutor para manter a trajectória do veículo controlada.",
          "Procedimentos do condutor, para recolher do ambiente rodoviário, as informações importantes para a tarefa de condução.",
          "Procedimentos do condutor para realizar manobras mais rapidamente."
        ],
        correctAnswer: "Procedimentos do condutor, para recolher do ambiente rodoviário, as informações importantes para a tarefa de condução.",
        image: images.image232
      },
      {
        question: "Como deve ser feita a carga e descarga de um veículo na via pública?",
        options: [
          "Sempre pela retaguarda.",
          "Sempre pela direita.",
          "Pela retaguarda ou pelo lado da faixa de rodagem junto da qual o veículo esteja parado ou estacionado."
        ],
        correctAnswer: "Pela retaguarda ou pelo lado da faixa de rodagem junto da qual o veículo esteja parado ou estacionado.",
        image: images.image233
      },
  
    ]
    ,
    10: [

      {
        question: "Se estacionar o veículo na faixa de rodagem desde anoitecer até ao amanhecer, deve utilizar alguma luz?",
        options: [
          "Não, mesmo que seja num local sem iluminação.",
          "Sim, as de presença (minimos), se a iluminação não permite reconhecer o veículo a 100 metros.",
          "Sim, as de cruzamento (médios), se a iluminação não permite reconhecer o veículo a 100 metros.",
          "Sim, as de estrada (máximos).",
        ],
        correctAnswer: "Sim, as de presença (minimos), se a iluminação não permite reconhecer o veículo a 100 metros.",
        image: images.image234
      },
  
      {
        question: "A que grupo pertece o sinal triângular?",
        options: [
          "Sinais temporários de perigo.",
          "Sinais temporários de obrigação.",
          "Sinais temporários de proibição."
        ],
        correctAnswer: "Sinais temporários de perigo.",
        image: images.image235
      },
  
      {
        question: "Em situações de chuva forte:",
        options: [
          "Aumenta a probabilidade de aquaplanagem (hidroplanagem).",
          "Reduz a probabilidade de aquaplanagem (hidroplanagem).",
          "Reduz a probabilidade de aquaplanagem (hidroplanagem), sobretudo a velocidade moderada."
        ],
        correctAnswer: "Aumenta a probabilidade de aquaplanagem (hidroplanagem).",
        image: images.image236
      },
  
      {
        question: "A definição de estacionamento é:",
        options: [
          "Imobilização de um veículo que constitua paragem e que seja motivada por circunstâncias próprias da circulação.",
          "Imobilização de um veículo que não constitua paraagem e que seja motivada por circunstâncias próprias da circulação.",
          "Imobilização de um veículo que constitua paragem e que seja motivada por circunstâncias de excesso de tráfego.",
          "Imobilição de um veículo que não constitua paragem e que não seja motivada por circunstâncias próprias da circulação.",
        ],
        correctAnswer: "Imobilição de um veículo que não constitua paragem e que não seja motivada por circunstâncias próprias da circulação.",
        image: images.image237
      },
      {
        question: "Os peões podem transitar pela faixa de rodagem nesta estrada?",
        options: [
          "Não, nesta estrada não podem transitar, já que não tem bermas.",
          "Sim, com prudência e por forma a não prejudicar o trânsito de veículos.",
          "Sim e devem fazê-lo pela esquerda da faixa de rodagem, em relação ao seu sentido de marcha.",
          "Sim, mas só quando necessitem atravessar.",
        ],
        correctAnswer: "Sim, com prudência e por forma a não prejudicar o trânsito de veículos.",
        image: images.image238
      },
      {
        question: "Os condutores não podem exceder as seguintes velocidades instantâneas (em quilómetros/hora):",
        options: [
          "Automóveis ligeiros de passageiros e mistos sem reboque dentro das localidades 60, fora das localidades 120.",
          "Automóveis ligeiros de passageiros e mistos sem reboque dentro das localidades 50, fora das localidades 120.",
          "Automóveis ligeiros de passageiros e mistos sem reboque dentro das localidades 60, fora das localidades 100.",
          "Automóveis ligeiros de passageiros e mistos sem reboque dentro das localidades 50, fora das localidades 100.",
        ],
        correctAnswer: "Automóveis ligeiros de passageiros e mistos sem reboque dentro das localidades 60, fora das localidades 120.",
        image: images.image239
      },
      {
        question: "Que veículos devem ter o seguro de responsabilidade civil para transitar na via pública?",
        options: [
          "Todos os veículos.",
          "Só os ciclomotores.",
          "Apenas os veículos automóveis.",
          "Os veículos a motor.",
        ],
        correctAnswer: "Os veículos a motor.",
        image: images.image240
      },
      {
        question: "É necessário verificar o nível do líquido de travão com frequência?",
        options: [
          "Sim e deve ser substituído dentro do período indicado pelo fabricante.",
          "Sim, mas não precisa de ser substituído",
          "Não, porque não se desgasta com o uso.",
          "Sim, para juntar óleo do motor em caso de necessidade.",
        ],
        correctAnswer: "Sim e deve ser substituído dentro do período indicado pelo fabricante.",
        image: images.image241
      },
      {
        question: "Para os condutores de transporte de serviço público ou de carga perigosa, quando em ecercício, a taxa de álcool deve ser:",
        options: [
          "0.3 mg/l.",
          "0.0 mg/l",
          "0.6 mg/l",
        ],
        correctAnswer: "0.6 mg/l",
        image: images.image242
      },
      {
        question: "Em especial à noite, com nevoeiro (cacimba), as luzes de estrada:",
        options: [
          "Devem ser evitadas porque reflectem-se no nevoeiro impedindo a visibilidade a maior distância.",
          "Devem ser usadas porque permitem uma maior visibilidade a maior distância.",
          "Devem ser evitadas porque permitem uma maior visibilidade a maior distância.",
          "São as mais aconselháveis para garantir alguma visibilidade.",
        ],
        correctAnswer: "Devem ser evitadas porque reflectem-se no nevoeiro impedindo a visibilidade a maior distância.",
        image: images.image243
      },
      {
        question: "O que indica o sinal?",
        options: [
          "Passagem de peões.",
          "Pista obrigatória para peões.",  
          "Passagem desnivelada para peões.",
        ],
        correctAnswer: "Passagem de peões.",
        image: images.image244
      },
      {
        question: "O que indica o sinal?",
        options: [
          "A presença de máquinas na via.",
          "Passagem de nível.",
          "Passagem de um veículo automóvel de cada vez."
        ],
        correctAnswer: "Passagem de nível.",
        image: images.image245
      },
      {
        question: "A distância de reacção é influenciada:",
        options: [
          "Pelo tempo dividido pela velocidade",
          "Pelo somatório do tempo mais a velocidade.",
          "Principalmente de factores externos ao condutor.",
          "Pelo tempo multiplicado pela velocidade.",
        ],
        correctAnswer: "Pelo tempo multiplicado pela velocidade.",
        image: images.image246
      },
      {
        question: "Quando existe um forte vento lateral corremos o perigo de sermos desviados da nossa trajectória. Nestas circunstâncias a melhor solução é:",
        options: [
          "Circular ao lado de um veículo pesado, se for possível. ",
          "Acelerar mais para vencer a força do vento.",
          "Moderar a velocidade e ajustar-nos às circuntâncias.",
          "Parar o veículo e aguardar até que o vento passe.",
        ],
        correctAnswer: "Moderar a velocidade e ajustar-nos às circuntâncias.",
        image: images.image247
      },
      {
        question: "O significado deste sinal é:",
        options: [
          "Área reservada para veículos de dimensões normais.",
          "Área reservada para veículos de pesos anormais.",
          "Área reservada para veículos de comprimentos anormais.",
          "Área reservada para veículos de dimensões anormais.",
        ],
        correctAnswer: "Área reservada para veículos de dimensões anormais.",
        image: images.image248
      },
      {
        question: "A definicão de lotação é:",
        options: [
          "Número de passageiros que o veículo pode transportar, não incluindo o condutor.",
          "Número de lugares que o veículo tem, incluindo o condutor.",
          "Número de passageiros que o veículo consiga transportar, incluindo o condutor.",
          "Número de lugares que o veículo tem, não incluindo o condutor.",
        ],
        correctAnswer: "Número de lugares que o veículo tem, incluindo o condutor.",
        image: images.image249
      },
      {
        question: "O agente regulador de trânsito que aparece na fotografia, manda:",
        options: [
          "Avançar o tráfego que venha da esquerda.",
          "Parar o tráfego que venha da direita.",
          "Avançar o tráfego que venha da direita.",
        ],
        correctAnswer: "Avançar o tráfego que venha da direita.",
        image: images.image250
      },
      {
        question: "Se pretender inverter o sentido de marcha, deve ter em conta...",
        options: [
          "que só é permitido fazê-lo nas rotundas.",
          "que a manobra deve ser feita em local e de forma a não prejudicar o trânsito.",
          "que é proibido fazê-lo em todos os cruzamentos e entrocamentos.",
          "que é proibido fazê-lo em dentro das localidades.",
        ],
        correctAnswer: "que a manobra deve ser feita em local e de forma a não prejudicar o trânsito.",
        image: images.image251
      },
      {
        question: "Em cada situação, a decisão que tomo:",
        options: [
          "Depende exclusivamente da sinalização que encontro no local.",
          "É consequência unicamente da intensidade do trânsito.",
          "Não é influenciada pelo estado físico em que me encontro.",
          "É sempre influenciada pela previsão que faço.",
        ],
        correctAnswer: "É sempre influenciada pela previsão que faço.",
        image: images.image252
      },
      {
        question: "São evitáveis os acidentes de viação?",
        options: [
          "Não, porque os acidentes ocorrem por acaso.",
          "Sim, podemos aprender a evitá-los e a reduzir as suas consequências.",
          "Sim, mas só se o estado das estradas melhorar.",
          "Sim, excepto os causados pelo mau estado dos pneus.",
        ],
        correctAnswer: "Sim, podemos aprender a evitá-los e a reduzir as suas consequências.",
        image: images.image253
      },
      {
        question: "É permitido que uma criança de 6 anos viaje no banco da frente de um automóvel?",
        options: [
          "Não, em nenhum caso.",
          "Sim, se não tiver bancos ou cintos de segurança na retaguarda.",
          "Sim, mesmo que não utilize cinto de segurança.",
          "Sim, sempre que utilize o cinto de segurança.",
        ],
        correctAnswer: "Sim, se não tiver bancos ou cintos de segurança na retaguarda.",
        image: images.image254
      },
      {
        question: "A distância de segurança, é um factor a considerar:",
        options: [
          "Apenas em condução urbana, devido à intensidade do trânsito.",
          "Nas estradas rurais pela diminuição dos limites de velocidade.",
          "Em qualquer situação."
        ],
        correctAnswer: "Em qualquer situação.",
        image: images.image255
      },
      {
        question: "Uma mulher grávida, é obrigada a utilizar o cinto de segurança?",
        options: [
          "Não, porque é prejudicial para a criança.",
          "Não é obrigatório, mas é aconselhável.",
          "Sim, mas apenas fora das cidades.",
          "Sim e é muito importante que esteja bem colocado porque senão, tanto ela como a criança, podem sofrer lesões graves em caso de acidente.",
        ],
        correctAnswer: "Sim e é muito importante que esteja bem colocado porque senão, tanto ela como a criança, podem sofrer lesões graves em caso de acidente.",
        image: images.image256
      },
      {
        question: "Pode uma criança com idade inferior a 3 anos viajar no banco da frente do automóvel?",
        options: [
          "Sim, sempre que utilize o cinto de segurança.",
          "Não, em nenhum caso.",
          "Sim, quando o automóvel não tenha nenhum cinto de segurança.",
          "Sim, utilizando um sistema de retenção virado para a retaguarda e com a almofada de ar frontal (airbag) do lado do passageiro desactivado.",
        ],
        correctAnswer: "Sim, utilizando um sistema de retenção virado para a retaguarda e com a almofada de ar frontal (airbag) do lado do passageiro desactivado.",
        image: images.image257
      },
      {
        question: "Conduzir sob influência de álcool, sob efeitos de substâncias legalmente consideradas como estupefacientes ou psicotrópicas, constitui contravenção:",
        options: [
          "Leve.",
          "Média.",
          "Grave."
        ],
        correctAnswer: "Grave.",
        image: images.image258
      },
  
    ]
    ,
    11: [

      {
        question: "Um condutor que expressa o descontentamento através de gestos ou palavras agressivas:",
        options: [
          "Está apenas, e bem, a demostrar o seu descontentamento com o comportamento dos outros.",
          "Manifesta agressividade e falta de civismo.",
          "Está a contribuir para mais e melhor cidadania no trânsito.",
          "Está a exercer um direito que lhe assiste perante a ignorância dos outros condutores.",
        ],
        correctAnswer: "Manifesta agressividade1 e falta de civismo.",
        image: images.image259
      },
  
      {
        question: "O que é a ergonomia de um veículo?",
        options: [
          "É a capacidade de adaptação do equipamento às particularidades de cada ser humano.",
          "É a capacidade de um condutor economizar no combustível.",
          "É a capacidade de um veículo economizar no combustível."
        ],
        correctAnswer: "É a capacidade de adaptação do equipamento às particularidades de cada ser humano.",
        image: images.image260
      },
  
      {
        question: "O significado deste sinal é:",
        options: [
          "Zona onde só podem passar três carros de cada vez.",
          "Congestionamento de tráfego.",
          "Zona de estacionamento em fila.",
          "Zona de paragem em fila.",
        ],
        correctAnswer: "Congestionamento de tráfego.",
        image: images.image261
      },
  
      {
        question: "A definição de tara é:",
        options: [
          "Peso do veículo com carga.",
          "Peso do veículo em vazio.",
          "Peso da carga que o veículo transporta.",
          "Peso do veículo mais o condutor.",
        ],
        correctAnswer: "Peso do veículo em vazio.",
        image: images.image262
      },
      {
        question: "As luzes de travagem dos automóveis tem a cor:",
        options: [
          "Branca ou amarela.",
          "Amarela ou alaranjada.",
          "Vermelha."
        ],
        correctAnswer: "Vermelha.",
        image: images.image264
      },
      {
        question: "Como é feito o processo de eliminação do álcool no organismo?",
        options: [
          "Pela urina e pela transpiração.",
          "Pelo ar expirado, pela urina e quantidade de água ingerida.",
          "Pelo fígado, pelo ar expirado, pela urina e pela transpiração.",
          "Pela quantidade de café e água que tome depois de beber.",
        ],
        correctAnswer: "Pelo fígado, pelo ar expirado, pela urina e pela transpiração.",
        image: images.image265
      },
      {
        question: "Nos veículos de mercadorias, a carga deve ser disposta de modo a que:",
        options: [
          "O principal peso fique sobre o eixo da retaguarda.",
          "Seja assegurando o equilíbrio do veículo, parado ou em movimento.",
          "Fique livre o maior espaço possível à retaguarda da caixa de carga."
        ],
        correctAnswer: "Seja assegurando o equilíbrio do veículo, parado ou em movimento.",
        image: images.image266
      },
      {
        question: "A marcha atrás, e uma manobra que deve ser efectuada...",
        options: [
          "o mais à direita possível, em local de boa visibilidade.",
          "o mais rapidamente possível, em local onde não prejudique o trânsito.",
          "lentamente e o mais possível à esquerda.",
          "rapidamente e no menor trajecto possível.",
        ],
        correctAnswer: "lentamente e o mais possível à esquerda.",
        image: images.image267
      },
      {
        question: "O que deve fazer o condutor se a fila da esquerda estiver a circular mais rapidamente?",
        options: [
          "Manter-se na fila de trânsito em que se encontra.",
          "Mudar de fila de trânsito.",
          "Sinalizar e mudar de fila de trânsito."
        ],
        correctAnswer: "Manter-se na fila de trânsito em que se encontra.",
        image: images.image268
      },
      {
        question: "O condutor de veículo utilizado no transporte colectivo de passageiros, só pode parar nas faixas de rodagem para:",
        options: [
          "Carregar e descarregar mercadorias, só durante o dia.",
          "Carregar e descarregar mercadorias, só durante a noite.",
          "A entrada e saída de passageiros nos locais especialmente destinados a esse fim.",
          "A entrada e saída de passageiros, em qualquer lugar que lhe dê mais jeito.",
        ],
        correctAnswer: "A entrada e saída de passageiros nos locais especialmente destinados a esse fim.",
        image: images.image269
      },
      {
        question: "O agente de trânsito que aparece na fotografia, manda:",
        options: [
          "Avançar o tráfego que venha da retaguarda.",
          "Avançar o tráfego que venha esquerda.",
          "Parar o tráfego que venha da esquerda."
        ],
        correctAnswer: "Avançar o tráfego que venha esquerda.",
        image: images.image270
      },
      {
        question: "O que é força centrífuga?",
        options: [
          "É a força aparente que `empurra´ os veículos para o interior das curvas;",
          "É a força aparente que `empurra´ os veículos para o exterior das curvas;",
          "É a força aparente que trava os veículos nas curvas.",
          "Uma força que só ocorre quando o veículo vai em linha recta.",
        ],
        correctAnswer: "É a força aparente que `empurra´ os veículos para o interior das curvas;",
        image: images.image271
      },
      {
        question: "Dentro das localidades, durante a noite:",
        options: [
          "Não é obrigatória a substituição dois sinais sonoros pelos sinais luminosos.",
          "É obrigatória a substituição dos sinais sonoros pelos sinais gestuais.",
          "É obrigatória a substituição dos sinais sonsoros pelos sinais luminosos.",
          "É escolha do condutor a susbstituição dos sinais sonoros pelos sinais gestuais.",
        ],
        correctAnswer: "É obrigatória a substituição dos sinais sonsoros pelos sinais luminosos.",
        image: images.image272
      },
      {
        question: "Podem ser submetidos às provas para a detecção de álcool ou substâncias estupefacientes ou psicotrópicas:",
      options: [
        "Apenas os condutores de veículos automóveis.",
        "Os peões, sempre que sejam intervenientes em acidentes de trânsito e os condutores.",
        "Todos os condutores e peões que transitem pela via pública,",
        "Só os condutores que sejam intervenientes em acidentes de trânsito.",
      ],
      correctAnswer: "Os peões, sempre que sejam intervenientes em acidentes de trânsito e os condutores.",
      image: images.image273
      },
      {
        question: "Nas pontes, túneis e passagens de nível:",
      options: [
        "Os animais atrelados ou não, devem seguir passo.",
        "Os animais só quando estiverem atrelados, devem seguir passo.",
        "Os animais quando não atrelados, devem seguir a passo de corrida,",
        "Os animais atrelados ou não, devem seguir a passo de corrida.",
      ],
      correctAnswer: "Os animais atrelados ou não, devem seguir passo.",
      image: images.image274
      },
      {
        question: "Se conduz muito tempo sem descansar...",
        options: [
          "aumenta a atenção do condutor.",
          "a condução torna-se perigosa.",
          "aumenta a segurança.",
          "o condutor relaxa-se e conduz melhor.",
        ],
        correctAnswer: "a condução torna-se perigosa.",
        image: images.image275
      },
      {
        question: "O que indica o sinal?",
        options: [
          "Trânsito proibido ao conjunto de veículos de mercadorias, de peso total superior a 10t.",
          "Trânsito proibido a veículos de peso por eixo superior a 10t.",
          "Trânsito proibido a veículos de peso por eixo múltiplo superior a 10t."
        ],
        correctAnswer: "Trânsito proibido a veículos de peso por eixo múltiplo superior a 10t.",
        image: images.image276
      },
      {
        question: "O que indica o sinal de perigo?",
        options: [
          "Controlo policial por pirilampos.",
          "Aproximação de uma estrada com prioridade.",
          "Sinalização luminosa."
        ],
        correctAnswer: "Sinalização luminosa.",
        image: images.image277
      },
      {
        question: "Depois de ter tomado bebidas alcoólicas:",
        options: [
          "O álcool entra rapidamente no sistema circulatório.",
          "O álcool entra directamente no sistema urinário.",
          "O álcool demora duas horas a entrar no sistema circulatório."
        ],
        correctAnswer: "O álcool entra rapidamente no sistema circulatório.",
        image: images.image278
      },
      {
        question: "O que indica o sinal?",
        options: [
          "Terreno falso à direita.",
          "Cruzamento facilmente congestionável.",
          "Congestionamento de tráfego."
        ],
        correctAnswer: "Congestionamento de tráfego.",
        image: images.image279
      },
      {
        question: "O sinal, pertence ao grupo de sinais de:",
        options: [
          "Pré-sinalização e de direcção.",
          "Direcção.",
          "Direcção para auto-estradas."
        ],
        correctAnswer: "Direcção para auto-estradas.",
        image: images.image280
      },
      {
        question: "A definição de tractor é:",
        options: [
          "Veículo a motor exclusivamente construído para desenvolver esforço de tracção, sem comportar carga útil.",
          "Veículo a automóvel exclusivamente construído para desenvolver esforço de tracção, sem comportar carga útil.",
          "Veículo a automóvel exclusivamente construído para desenvolver esforço de tracção, comportando carga útil.",
          "Veículo a automóvel exclusivamente construído para desenvolver esforço de motor, comportando alguma carga.",
        ],
        correctAnswer: "Veículo a automóvel exclusivamente construído para desenvolver esforço de tracção, sem comportar carga útil.",
        image: images.image281
      },
      {
        question: "A condução em dias de chuva provoca um aumento do risco de acidente, por causa de factores como:",
        options: [
          "Menor visibilidade, menor aderência e maior stress físico.",
          "Maior tempo de reacção e menor tempo de paragem.",
          "Piso mais escorregadio e menor distância de paragem.",
          "Diminuição do tempo de reacção por falta de visibilidade.",
        ],
        correctAnswer: "Menor visibilidade, menor aderência e maior stress físico.",
        image: images.image282
      },
      {
        question: "Como deve actuar o condutor quando tem que fazer uma curva?",
        options: [
          "Reduzir a velocidade, já dentro da curva.",
          "Aumentar a velocidade, antes de entrar na curva.",
          "Adaptar a velocidade, antes de entrar na curva.",
          "Pressionar o pedal de embreiagem e não acelerar dentro da curva.",
        ],
        correctAnswer: "Adaptar a velocidade, antes de entrar na curva.",
        image: images.image283
      },
      {
        question: "O significado deste sinal é:",
        options: [
          "Passagem estreita.",
          "Só veículos pesados de passageiros.",
          "Um veículos de cada vez.",
          "Só veículos pesados de mercadorias.",
        ],
        correctAnswer: "Um veículos de cada vez.",
        image: images.image263
      },
  
    ]
    ,


    12: [

      {
        question: "O que indica a marca rodoviária branca?",
        options: [
          "Indica a existência de bandas sonoras.",
          "Indica a existência de lombas.",
          "Indica a redução de de filas de trânsito.",
        ],
        correctAnswer: "Indica a existência de lombas.",
        image: images.image284
      },
      {
        question: "O que indica o sinal de informação?",
        options: [
          "Inicio da faixa reservada para táxis do lado esquerdo.",
          "Parque de estacionamento para táxis.",
          "Área reservada para táxis.",
        ],
        correctAnswer: "Área reservada para táxis.",
        image: images.image285
      },
      {
        question: "Quando existe dificuldade na recolha de informação, a velocidade:",
        options: [
          "Deve diminuir.",
          "Deve aumentar.",
          "Deve manter-se, desde que as luzes do veículo estejam ligadas.",
        ],
        correctAnswer: "Deve diminuir.",
        image: images.image286
      },
      {
        question: "Se perceber o princípio de um incêndio:",
        options: [
          "Actue de imediato, desligando o motor do veículo e utilizando um extintor.",
          "Actue de imediato, desligando as luzes do veículo e utilizando um extintor.",
          "Actue de imediato, desligando o ar condicionado do veículo e utilizando utilizando um extintor.",
        ],
        correctAnswer: "Actue de imediato, desligando o motor do veículo e utilizando um extintor.",
        image: images.image287
      },
      {
        question: "O que deve ser ajustado antes de iniciar a marcha?",
        options: [
          "De forma folgada o cinto de segurança.",
          "A distância do assento aos pedais, a inclinação das costas do banco e o encosto de cabeça.",
          "O encosto de cabeça e o cinto de segurança.",
        ],
        correctAnswer: "A distância do assento aos pedais, a inclinação das costas do banco e o encosto de cabeça.",
        image: images.image288
      },
      {
        question: "A distância de segurança entre veículos em marcha depende:",
        options: [
          "Apenas da pressa do condutor.",
          "De que circulem em autoestradas, podendo ser mais pequena neste caso.",
          "Sempre da velocidade.",
          "Da capacidade de travagem do veículo.",
        ],
        correctAnswer: "Sempre da velocidade.",
        image: images.image289
      },
      {
        question: "Se um indivíduo atingir uma TAS de 1.2 g/l às 0 horas, só por volta das:?",
      options: [
        "4 horas do dia seguinte é que terá eliminado completamente o álcool no seu sangue, se dormir bem.", 
        "8 horas do dia seguinte é que terá eliminado completamente o álcool no seu sangue.",
        "12 horas do dia seguinte é que terá eliminado completamente o álcool no seu sangue.",
        "22 horas do dia seguinte é que terá eliminado completamente o álcool no seu sangue."],
        correctAnswer: "12 horas do dia seguinte é que terá eliminado completamente o álcool no seu sangue.",
        image: images.image290
      },
      {
        question: "Quem exceder de 30Km/h a 60Km/h de velocidade (automóveis ligeiros e motociclos) os limites, fora das localidades é punido:",
      options: [
        "Com multa de 2.000,00 Mt e contravenção média.",
        "Com multa de 2.000,00 Mt e contravenção leve.",
        "Com multa de 2.000,00 Mt e contravenção grave.",
        "Com multa de 3.000,00 Mt e contravenção média.",
      ],
        correctAnswer: "Com multa de 2.000,00 Mt e contravenção média.",
        image: images.image291
      },
      {
        question: "Desde o anoitecer até o amanhecer, pode deixar as luzes de cruzamento acesas quando o veículo estiver estacionado?",
        options: [
          "Sim, é obrigatório.",
          "Não, é proibido.",
          "Não, nesta situação deve utilizar as de estrada (máximos).",
          "Não, é proibido deixar qualquer luz acesa com o veículo estacionado.",
        ],
        correctAnswer: "Não, é proibido.",
        image: images.image292
      },
      {
        question: "Quais são os efeitos mais comuns da fadiga ao volante?",
        options: [
          "Sentir fome e sede o que provoca a necessidade de se deslocar com maior velocidade para chegar mais rápido ao seu destino.",
          "A dificuldade em manter o veículo, dentro dos limites da faixa de rodagem.",
          "Sentir-se energético podendo controlar melhorar o veículo.",
        ],
        correctAnswer: "A dificuldade em manter o veículo, dentro dos limites da faixa de rodagem.",
        image: images.image293
      },
      {
        question: "Deve ter alguma precaução especial quando circula dentro das localidades?",
        options: [
          "Não.",
          "Sim, moderar a velocidade, especialmente nas vias marginadas por edificações.",
          "Sim, utilizar os sinais sonoros quando se aproximar de peões.",
          "Sim, apenas não ficar imobilizado nos cruzamentos ou entrocamentos.",
        ],
        correctAnswer: "Sim, moderar a velocidade, especialmente nas vias marginadas por edificações.",
        image: images.image294
      },
      {
        question: "O significado deste sinal é:",
        options: [
          "Indicação de aproximação de entrada de autoestrada.",
          "Indicação de aproximação de entrada de via rápida.",
          "Indicação de aproximação de saída de autoestrada.",
          "Indicação de aproximação de saída de via rápida.",
        ],
        correctAnswer: "Indicação de aproximação de saída de autoestrada.",
        image: images.image295
      },
      {
        question: "Ao perceer que existe um acidente ou vitímas de doença súnita, deve:",
        options: [
          "Colocar o triângulo de sinalização, no mínimo a 25 metros do local do acidente e de forma a ser vísivel a pelo menos 100 metros.",
          "Colocar o triângulo de sinalização, no mínimo a 30 metros do local do acidente e de forma a ser vísivel a pelo menos 150 metros.",
          "Vestir o colete retrorrefletor e colocar o triângulo de sinalização, no mínimo a 30 metros do local do acidente e de forma a ser vísivel a pelo menos 100 metros."
        ],
        correctAnswer: "Vestir o colete retrorrefletor e colocar o triângulo de sinalização, no mínimo a 30 metros do local do acidente e de forma a ser vísivel a pelo menos 100 metros.",
        image: images.image296
      },
      {
        question: "Como devo actuar perante a diminuição da aderência, que provoca o aumento da distância de travagem?",
        options: [
          "Aumentar a velocidade.",
          "A diminuição da aderência diminui a distância de travagem.",
          "Diminuir a velocidade.",
          "Manter a velocidade."
        ],
        correctAnswer: "Diminuir a velocidade.",
        image: images.image297
      },
      {
        question: "Como deve ser feita a carga e descarga de um veículo na via pública?",
        options: [
          "Pela retaguarda ou pelo lado da faixa de rodagem junto da qual o veículo esteja parado ou estacionado.",
          "Sempre pela retaguarda.",
          "Sempre pela direita."
          
        ],
        correctAnswer: "Pela retaguarda ou pelo lado da faixa de rodagem junto da qual o veículo esteja parado ou estacionado.",
        image: images.image298
      },
      {
        question: "O sinal realizado pelo operador da obra, indica:",
        options: [
          "Paragem obrigatória.",
          "Aproximação de uma estrada com prioridade.",
          "Paragem obrigatória em quatro vias.",
          "Avance.",
        ],
        correctAnswer: "Paragem obrigatória.",
        image: images.image299
      },
      {
        question: "Os condutores não podem exceder as seguintes velocidades instantâneas (em quilómetros/hora):",
        options: [
          "Automóveis ligeiros de passageiros e mistos sem reboque dentro das localidades 50, fora das localidades 120.",
          "Automóveis ligeiros de passageiros e mistos sem reboque dentro das localidades 60, fora das localidades 120.",
          "Automóveis ligeiros de passageiros e mistos sem reboque dentro das localidades 60, fora das localidades 100.",
          "Automóveis ligeiros de passageiros e mistos sem reboque dentro das localidades 50, fora das localidades 100.",
        ],
        correctAnswer: "Automóveis ligeiros de passageiros e mistos sem reboque dentro das localidades 60, fora das localidades 120.",
        image: images.image300
      },
      {
        question: "A ingestão de drogas:",
        options: [
          "Não afecta o equilíbrio e a personalidade do condutor.",
          "Só afecta a personalidade do condutor.",
          "Afecta o equilíbrio e a personalidade do condutor.",
          "Se for um consumidor habitual têm pouca influência no seu acto de condução.",
        ],
        correctAnswer: "Afecta o equilíbrio e a personalidade do condutor.",
        image: images.image301
      },
      {
        question: "Deve ajustar o banco e o volante para:",
        options: [
          "Que o condutor esteja posicionado o mais próximo possível do volante.",
          "Que o condutor possa manussear o rádio, o GPS e o telemóvel em segurança.",
          "Poder proporcionar um maior conforto ao condutor, tendo em atenção a sua estatura."
        ],
        correctAnswer: "Poder proporcionar um maior conforto ao condutor, tendo em atenção a sua estatura.",
        image: images.image302
      },
      {
        question: "O siginificado deste sinal é:",
        options: [
          "Bois ou vacas.",
          "Animais.",
          "Zona de pasto de animais.",
          "Travessia para animais.",
        ],
        correctAnswer: "Animais.",
        image: images.image303
      },
      {
        question: "Para ter a possição mais correcta, o condutor deve ter em conta:",
        options: [
          "A morfologia física, a utilização eficaz dos controlos e comandos e a segurança e o conforto do condutor.",
          "O ajuste do cinto de segurança e a fácil regulação dos espelhos retrovisores.",
          "O tipo de via onde transita e as condições adversas."
        ],
        correctAnswer: "A morfologia física, a utilização eficaz dos controlos e comandos e a segurança e o conforto do condutor.",
        image: images.image304
      },
      {
        question: "O condutor que pretende mudar de direcção para a esquerda deve:",
        options: [
          "Aproximar-se, com a necessária antecedência,da margem direita da faixa de rodagem e efectuar a manobra no trajecto mais curto.",
          "Aproximar-se, com a necessária antecedência,da margem esquerda da faixa de rodagem e efectuar a manobra no trajecto mais longo.",
          "Aproximar-se, com a necessária antecedência,da margem esquerda da faixa de rodagem e efectuar a manobra no trajecto mais curto.",
          "Aproximar-se, com a necessária antecedência,do eixo da via e efectuar a manobra no trajecto mais curto.",
        ],
        correctAnswer: "Aproximar-se, com a necessária antecedência,da margem esquerda da faixa de rodagem e efectuar a manobra no trajecto mais curto.",
        image: images.image305
      },
      {
        question: "O significado deste sinal é:",
        options: [
          "Parque de estacionamento para veículos de 12 toneladas.",
          "Parque de estacionamento para veículos de alta tonelagem.",
          "Parque de estacionamento para veículos de 12 eixos.",
          "Parque de estacionamento para veículos de mais de 12 metros de comprimento.",
        ],
        correctAnswer: "Parque de estacionamento para veículos de alta tonelagem.",
        image: images.image306
      },
      {
        question: "O que indica o sinal?",
        options: [
          "Pista obrigatória para veículos de tracção manual.",
          "Pista obrigatória para peôes.",
          "Pista obrigatória para peôes e velocípedes.",
          "Trânsito proibido a velocípedes e peôes.",
        ],
        correctAnswer: "Pista obrigatória para peôes e velocípedes.",
        image: images.image307
      },
      {
        question: "O significado deste sinal é?",
        options: [
          "Obrigação de ceder passagem no próximo cruzamento.",
          "Paragem obrigatória.",
          "Dar prioridade aos veículos automóveis.",
          "Dar prioridade aos veículos automóveis pesados.",
        ],
        correctAnswer: "Paragem obrigatória.",
        image: images.image308
      },
    ]
    ,
    13: [

      {
        question: "Como se mede a quantidade de álcool ingerido?",
        options: [
          "Pela proporção entre a quantidade de álcool ingerido num determinado espaço de tempo.",
          "Pela proporção entre a quantidade de álcool existente num determinado volume de sangue.",
          "Pela proporção entr a quantidade de álcool ingerido em duas horas.",
        ],
        correctAnswer: "Pela proporção entre a quantidade de álcool existente num determinado volume de sangue.",
        image: images.image309
      },
      {
        question: "Os condutores não podem exceder as seguintes velocidades instantâneas (em quilómetros/hora):",
        options: [
          "Motociclos com carro, dentro das localidades 40, fora das localidades 70.",
          "Motociclos com carro, dentro das localidades 50, fora das localidades 80.",
          "Motociclos com carro, dentro das localidades 50, fora das localidades 70.",
          "Motociclos com carro, dentro das localidades 60, fora das localidades 90."
        ],
        correctAnswer: "Motociclos com carro, dentro das localidades 50, fora das localidades 70.",
        image: images.image310
      },
      {
        question: "A direcção assistida permite:",
        options: [
          "Aumentar o ângulo de viragem.",
          "Diminuir o esforço do condutor no volante.",
          "Diminuir a desmultiplicação no volante.",
          "Efectuar as curvas de uma forma mais rápida."
        ],
        correctAnswer: "Diminuir o esforço do condutor no volante.",
        image: images.image311
      },
      {
        question: "A distância de reacção é influenciada por:",
        options: [
          "Velocidade e tempo de reacção.",
          "Distância de travagem e tempo de reacção.",
          "Tempo de reacção e estado da via.",
          "Apenas por factores externos ao condutor.",
        ],
        correctAnswer: "Velocidade e tempo de reacção.",
        image: images.image312
      },
      {
        question: "O estado de alerta do condutor, é influenciado pela fadiga, afecrando a forma como:",
        options: [
          "O veículo se comporta no ambiente rodoviário.",
          "O condutor recolhe as informações relevantes do ambiente rodoviário.",
          "O condutor realiza a manobra de ultrapassagem."
        ],
        correctAnswer: "O condutor recolhe as informações relevantes do ambiente rodoviário.",
        image: images.image313
      },
      {
        question: "Nas descidas de inclinação acentuada:",
        options: [
          "Os automóveis ligeiros não podem transitar sem utilizarem o motor como auxiliar do travão.",
          "Todos os automóveis não podem transitar sem utilizarem o motor como auxiliar do travão.",
          "Os automóveis pesados não podem transitar sem utilizarem o motor como auxiliar do travão.",
          "Só os automóveis pesados de passageiros não podem transitar sem utilizarem o motor como auxiliar do travão."
        ],
        correctAnswer: "Os automóveis pesados não podem transitar sem utilizarem o motor como auxiliar do travão.",
        image: images.image314
      },
      {
        question: "Se passar por um acidente ou por vítimas de doenças súbita, deve:",
        options: [
          "Ligar de imediato para o hospital.",
          "Iniciar de imediato as ações de primeiro socorro mesmo que não domine os procedimentos.",
          "Iniciar de imediato as ações para evitar que a situação de emergência se agrave, incluindo proceder à segurança do local, das vítimas e dos que prestam socorro.",
        ],
        correctAnswer: "Iniciar de imediato as ações para evitar que a situação de emergência se agrave, incluindo proceder à segurança do local, das vítimas e dos que prestam socorro.",
        image: images.image315
      },
      {
        question: "A distância de reacção é:",
        options: [
          "A distância percorrida pelo veículo desde que o condutor acciona o travão até parar.",
          "A distância percorrida pelo veículo desde que o condutor vê o perigo até reagir.",
          "A distância percorrida pelo veículo desde que o condutor vê o perigo até o perigo até parar.",
          "A distância percorrida pelo veículo desde que o condutor vê o perigo."
        ],
        correctAnswer: "A distância percorrida pelo veículo desde que o condutor vê o perigo até reagir.",
        image: images.image316
      },
      {
        question: "Quem exceder em mais de 30Km/h de velocidade (automóveis ligeiros e motociclos) os limites, fora das localidades é punido:",
      options: [
        "Com multa de 2.000,00 Mt e contravenção leve.",
        "Com multa de 1.000,00 Mt e contravenção leve.",
        "Com multa de 1.000,00 Mt e contravenção média.",
        "Com multa de 1.000,00 Mt e contravenção grave.",
      ],
      correctAnswer: "Com multa de 1.000,00 Mt e contravenção leve.",
      image: images.image317
      },
      {
        question: "Quem exceder de 40Km/h até 60Km/h de velocidade (automóveis ligeiros e motociclos) os limites, dentro das localidades é punido:",
      options: [
        "Com multa de 4.000,00 Mt e contravenção greve.",
        "Com multa de 6.000,00 Mt e contravenção grave.",
        "Com multa de 4.000,00 Mt e contravenção média.",
        "Com multa de 2.000,00 Mt e contravenção grave.",
      ],
      correctAnswer: "Com multa de 4.000,00 Mt e contravenção greve.",
      image: images.image318
      },
      {
        question: "Em especial à noite, com nevoeiro (cacimba), as luzes de estrada:",
        options: [
          "Devem ser usadas porque permitem uma maior visibilidade a maior distância.",
          "Devem ser evitadas porque refletem-se no nevoeiro impedindo a visibilidade a maior distância.",
          "Devem ser evitadas porque permitem uma maior visibilidade a maior distância.",
          "São as mais aconselháveis para garantir alguma visibilidade."
        ],
        correctAnswer: "Devem ser evitadas porque refletem-se no nevoeiro impedindo a visibilidade a maior distância.",
        image: images.image319
      },
      {
        question: "A distância de travagem depende principalmente de que factores?",
        options: [
          "Estado psicofísico do condutor e velocidade do veículo.",
          "Tipo e estado da via, estado e velocidade do veículo.",
          "Estado do veículo, tipo de via e visibilidade.",
          "Só depende do estado físico e psiquico do condutor."
        ],
        correctAnswer: "Tipo e estado da via, estado e velocidade do veículo.",
        image: images.image320
      },
      {
        question: "Numa paragem ou estacionamento irregular:",
        options: [
          "A contravenção é punida com multa de 500,00 Mt.",
          "A contravenção é punida com multa de 1000,00 Mt.",
          "A contravenção é punida com multa de 2000,00 Mt.",
          "A contravenção é punida com multa de 3000,00 Mt."
        ],
        correctAnswer: "A contravenção é punida com multa de 500,00 Mt.",
        image: images.image321
      },
      {
        question: "Quem exceder de 30Km/h até 60Km/h de velocidade (automóveis ligeiros e motociclos) os limites, fora das localidades é punido:",
        options: [
          "Com multa de 2.000,00 Mt e contravenção média.",
          "Com multa de 3.000,00 Mt e contravenção média.",
          "Com multa de 2.000,00 Mt e contravenção leve.",
          "Com multa de 2.000,00 Mt e contravenção grave.",
        ],
        correctAnswer: "Com multa de 2.000,00 Mt e contravenção média.",
        image: images.image322
      },
      {
        question: "Todos os condutores de veículos ou animais são obrigados a...",
        options: [
          "abandonar os veículos nos locais de estacionamento sem motivo justificado.",
          "obedecer ao sinal de paragem feito pelas autoridades com competências para fiscalização do tânsito.",
          "reduzir ou suspender intecionalmente a circulação, formando filas de trânsito desnecessárias.",
        ],
        correctAnswer: "obedecer ao sinal de paragem feito pelas autoridades com competências para fiscalização do tânsito.",
        image: images.image323
      },
      {
        question: "Qual das seguintes é uma afirmação falsa:",
        options: [
          "O sistema de circulação rodoviária é um conjunto de elementos interligados e dependentes.",
          "O homem é o elemento mais importante do sistema rodoviário.",
          "O acidente resulta sempre da falta de vários elementos do sistema rodoviário.",
          "A probabilidade de acidente aumenta quando há uma alteração na interacção entre os vários elementos do sistema rodoviário."
        ],
        correctAnswer: "O acidente resulta sempre da falta de vários elementos do sistema rodoviário.",
        image: images.image324
      },
      {
        question: "Quem não teve uma boa noite de descanso:",
        options: [
          "Mais facilmente se torna vítima de estados de fadiga.",
          "Deve tomar mais cafés durante o dia enquanto conduz.",
          "Deve beber muita água durante o dia enquanto conduz.",
          "Não afecta a sua capacidade de condução."
        ],
        correctAnswer: "Mais facilmente se torna vítima de estados de fadiga.",
        image: images.image325
      },
      {
        question: "Em caso de nevoeiro (cacimba), o que devemos ter presente, ao considerar a distância de segurança?",
        options: [
          "Que basta manter uma distância pequena independentemente da velocidade.",
          "Que essa disância depende unicamente do tipo de veículo que vai à nossa frente.",
          "Que há zonas mais densas onde a visibilidade repentinamente se reduz.",
          "Que como a velocidade praticada pelos veículos é menor devemos seguir mais perto possível do veículo da frente."
        ],
        correctAnswer: "Que há zonas mais densas onde a visibilidade repentinamente se reduz.",
        image: images.image326
      },
      {
        question: "O condutor está suejito ao aparecimento de fadiga, quando circula com trânsito intenso?",
        options: [
          "Está porque é uma situação de trânsito monótona o que provoca fadiga.",
          "Não está porque circula a velocidade reduzida.",
          "Não está porque nesta situação pode destacar devido à pouca velocidade do trânsito.",
        ],
        correctAnswer: "Está porque é uma situação de trânsito monótona o que provoca fadiga.",
        image: images.image327
      },
      {
        question: "Os sistemas de segurança activa de um veículo...",
        options: [
          "ajudam o condutor a reduzir a possibilidade de ter um acidente.",
          "minimizam as lesões em caso de acidente.",
          "eliminam a possibilidade de sofrer lesões em caso de acidente.",
        ],
        correctAnswer: "ajudam o condutor a reduzir a possibilidade de ter um acidente.",
        image: images.image328
      },
      {
        question: "O espaço percorrido pelo veículo durante o tempo de reacção do condutor não é sempre o mesmo e depende:",
        options: [
          "Só do tempo da reacção do condutor e não tem influência a velocidade do veículo.",
          "Só da velocidade do veículo e não tem influência o tempo de reacção do condutor.",
          "Do tempo de reacção e da velocidade do veículo.",
          "Principalmente de factores externos ao condutor.",
        ],
        correctAnswer: "Do tempo de reacção e da velocidade do veículo.",
        image: images.image329
      },
      {
        question: "Parar ou estacionar, é proibido:",
        options: [
          "A menos de 3 metros para a frente e 15 metros para um e outro lado dos sinais indicativos da paragem dos veículos de transporte colectivo de passageiros, consoante circulem ou não sobre carris.",
          "A menos de 5 metros para a frente e 15 metros para um e outro lado dos sinais indicativos da paragem dos veículos de transporte colectivo de passageiros, consoante circulem ou não sobre carris.",
          "A menos de 3 metros para a frente e 10 metros para um e outro lado dos sinais indicativos da paragem dos veículos de transporte colectivo de passageiros, consoante circulem ou não sobre carris.",
          "A menos de 1 metros para a frente e 10 metros para um e outro lado dos sinais indicativos da paragem dos veículos de transporte colectivo de passageiros, consoante circulem ou não sobre carris.",
        ],
        correctAnswer: "A menos de 3 metros para a frente e 15 metros para um e outro lado dos sinais indicativos da paragem dos veículos de transporte colectivo de passageiros, consoante circulem ou não sobre carris.",
        image: images.image330
      },
      {
        question: "TTodo o condutor de veículos ou animais é obrigado:",
        options: [
          "Sempre que não haja obstâculos que o impeça, a facilitar imediatamente a ultrapassagem desviando-se o mais possível para a direita e não aumentar a sua velocidade enquanto não for ultrapassado.",
          "Sempre que não haja obstâculos que o impeça, a facilitar imediatamente a ultrapassagem desviando-se o mais possível para a esquerda e aumentar a sua velocidade enquanto não for ultrapassado.",
          "Sempre que não haja obstâculos que o impeça, a facilitar imediatamente a ultrapassagem desviando-se o mais possível para a esquerda e não aumentar a sua velocidade enquanto não for ultrapassado.",
          "Sempre que não haja obstâculos que o impeça, a facilitar imediatamente a ultrapassagem desviando-se o mais possível para o eixo da via e não aumentar a sua velocidade enquanto não for ultrapassado.",
        ],
        correctAnswer: "Sempre que não haja obstâculos que o impeça, a facilitar imediatamente a ultrapassagem desviando-se o mais possível para a esquerda e não aumentar a sua velocidade enquanto não for ultrapassado.",
        image: images.image331
      },
      {
        question: "A expressão ``TRAVAR COM O MOTOR´´ significa:",
        options: [
          "Desligar o motor, mantendo uma mudança engrenada.",
          "Utilizar o motor de arranque par auxiliar a travagem.",
          "Engrenar uma mudança de maior força em andamento e não acelerar.",
          "Engrenar uma mudança de menor força em andamento e não acelerar.",
        ],
        correctAnswer: "Engrenar uma mudança de maior força em andamento e não acelerar.",
        image: images.image332
      },
      {
        question: "Se o condutor que segue à minha frente assinala a manobra de mudança de direcção para direita, posso ultrapassar?",
        options: [
          "Sim pela direita.",
          "Sim, pela esquerda, certificando-se que o pode fazer sem perigo de acidente.",
          "Não.",
          "Sim, pela direita ou pela esquerda, sempre que o veículo não esteja em movimento.",
        ],
        correctAnswer: "Sim, pela esquerda, certificando-se que o pode fazer sem perigo de acidente.",
        image: images.image333
      },
    
    ]
    

  
};

export default quizzes;
